<template>
    <div class="row">
        <!-- DHLPackingStationDE -->
        <template
            v-if="
                value.showPickupStation &&
                selectedCountry.isoCode2 === 'DE' &&
                addressType === '2'
            "
        >
            <div class="col-12">
                <div class="row">
                    <div
                        v-if="
                            isInOptionalFields(
                                'de',
                                'delivery_address.salutation'
                            )
                        "
                        class="col-12 col-sm-4"
                    >
                        <div
                            v-validate="
                                isInRequiredFields(
                                    'de',
                                    'delivery_address.salutation'
                                )
                            "
                            class="input-unit"
                        >
                            <salutation-select
                                :id="'txtSalutation' + _uid"
                                :address-data="value"
                                :address-type="addressType"
                                :enabled-address-fields="optionalAddressFields"
                                @input="
                                    emitInputEvent($event.field, $event.value)
                                "
                            ></salutation-select>
                            <label :for="'txtSalutation' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressSalutation",
                                        "de",
                                        "delivery_address.salutation"
                                    )
                                }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="row">
                    <div
                        v-if="
                            (isInOptionalFields(
                                'de',
                                'delivery_address.salutation'
                            ) &&
                                value.gender === 'company') ||
                            (isInOptionalFields(
                                'de',
                                'delivery_address.name1'
                            ) &&
                                !isInOptionalFields(
                                    'de',
                                    'delivery_address.salutation'
                                ))
                        "
                        class="col-12 col-sm-6"
                    >
                        <div
                            class="input-unit"
                            data-model="name1"
                            data-validate="text"
                        >
                            <input
                                :id="'txtCompany' + _uid"
                                :value="value.name1"
                                data-testing="packing-station-de-company"
                                inputmode="text"
                                maxlength="30"
                                name="company"
                                type="text"
                                @input="
                                    emitInputEvent('name1', $event.target.value)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtCompany' + _uid"
                                >{{
                                    $translate(
                                        "Ceres::Template.addressCompany"
                                    )
                                }}*</label
                            >
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="row">
                    <div
                        v-if="
                            isInOptionalFields('de', 'delivery_address.title')
                        "
                        class="col-12 col-sm-4"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'delivery_address.title'
                                )
                            "
                            class="input-unit"
                            data-model="title"
                        >
                            <input
                                :id="'txtTitle' + _uid"
                                :value="value.title"
                                inputmode="email"
                                maxlength="30"
                                name="title"
                                type="text"
                                @input="
                                    emitInputEvent('title', $event.target.value)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtTitle' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressTitle",
                                        "de",
                                        "delivery_address.title"
                                    )
                                }}
                            </label>
                        </div>
                    </div>

                    <template
                        v-if="areNameFieldsShown('de', 'delivery_address')"
                    >
                        <!-- First name -->
                        <div class="col-12 col-sm-4">
                            <div
                                v-validate:text="
                                    areNameFieldsRequired(
                                        'de',
                                        'delivery_address'
                                    )
                                "
                                class="input-unit"
                                data-model="name2"
                            >
                                <input
                                    :id="'txtFirstName' + _uid"
                                    :value="value.name2"
                                    data-testing="packing-station-de-firstname"
                                    inputmode="text"
                                    maxlength="19"
                                    name="firstName"
                                    type="text"
                                    @input="
                                        emitInputEvent(
                                            'name2',
                                            $event.target.value
                                        )
                                    "
                                    @keypress="filterCharacters($event)"
                                />
                                <label :for="'txtFirstName' + _uid"
                                    >{{
                                        $translate(
                                            "Ceres::Template.addressFirstName"
                                        )
                                    }}
                                    <template
                                        v-if="
                                            areNameFieldsRequired(
                                                'de',
                                                'delivery_address'
                                            )
                                        "
                                        >*</template
                                    >
                                </label>
                            </div>
                        </div>

                        <!-- Last name -->
                        <div class="col-12 col-sm-4">
                            <div
                                v-validate:text="
                                    areNameFieldsRequired(
                                        'de',
                                        'delivery_address'
                                    )
                                "
                                class="input-unit"
                                data-model="name3"
                            >
                                <input
                                    :id="'txtLastName' + _uid"
                                    :value="value.name3"
                                    data-testing="packing-station-de-lastname"
                                    maxlength="19"
                                    name="lastName"
                                    type="text"
                                    @input="
                                        emitInputEvent(
                                            'name3',
                                            $event.target.value
                                        )
                                    "
                                    @keypress="filterCharacters($event)"
                                />
                                <label :for="'txtLastName' + _uid"
                                    >{{
                                        $translate(
                                            "Ceres::Template.addressLastName"
                                        )
                                    }}
                                    <template
                                        v-if="
                                            areNameFieldsRequired(
                                                'de',
                                                'delivery_address'
                                            )
                                        "
                                        >*</template
                                    >
                                </label>
                            </div>
                        </div>
                    </template>

                    <div v-else class="col-12 col-sm-8">
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'delivery_address.contactPerson'
                                )
                            "
                            class="input-unit"
                            data-model="contactPerson"
                        >
                            <input
                                :id="'txtContactPerson' + _uid"
                                :value="value.contactPerson"
                                inputmode="text"
                                maxlength="19"
                                name="lastName"
                                type="text"
                                @input="
                                    emitInputEvent(
                                        'contactPerson',
                                        $event.target.value
                                    )
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtContactPerson' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressContactPerson",
                                        "de",
                                        "delivery_address.contactPerson"
                                    )
                                }}
                            </label>
                        </div>
                    </div>

                    <!-- Additional name -->
                    <div
                        v-if="
                            isInOptionalFields('de', 'delivery_address.name4')
                        "
                        class="col-12 col-sm-4"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'delivery_address.name4'
                                )
                            "
                            class="input-unit"
                            data-model="name4"
                        >
                            <input
                                :id="'txtAdditionalName' + _uid"
                                :value="value.name4"
                                inputmode="text"
                                maxlength="30"
                                name="decorateName"
                                type="text"
                                @input="
                                    emitInputEvent('name4', $event.target.value)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtAdditionalName' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressAdditionalName",
                                        "de",
                                        "delivery_address.name4"
                                    )
                                }}
                            </label>
                        </div>
                    </div>

                    <!-- Phone number -->
                    <div
                        v-if="
                            isInOptionalFields(
                                'de',
                                'delivery_address.phoneNumber'
                            )
                        "
                        class="col-12 col-sm-4"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'delivery_address.phoneNumber'
                                )
                            "
                            class="input-unit"
                            data-model="telephone"
                        >
                            <input
                                :id="'txtTelephone' + _uid"
                                :value="value.telephone"
                                inputmode="tel"
                                maxlength="30"
                                name="telephone"
                                type="tel"
                                @input="
                                    emitInputEvent(
                                        'telephone',
                                        $event.target.value
                                    )
                                "
                                @keypress="
                                    onlyNumbers('telephone', _uid, $event)
                                "
                            />
                            <label :for="'txtTelephone' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressTelephone",
                                        "de",
                                        "delivery_address.phoneNumber"
                                    )
                                }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="isParcelOrOfficeAvailable" class="col-12">
                <div class="row">
                    <div class="col-12">
                        <input
                            :id="'showPickup' + _uid"
                            :checked="value.showPickupStation"
                            name="togglePickup"
                            type="checkbox"
                            @change="togglePickupStation($event.target.checked)"
                        />
                        <label :for="'showPickup' + _uid">{{
                            $translate("Ceres::Template.addressToPickupStation")
                        }}</label>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="row">
                    <!-- Packstation, Postfiliale -->
                    <div class="col-12 col-sm-8">
                        <div
                            class="input-unit"
                            data-model="address1"
                            data-validate=""
                        >
                            <select
                                :id="'address1' + _uid"
                                :value="value.address1"
                                class="custom-select"
                                @change="
                                    emitInputEvent(
                                        'address1',
                                        $event.target.value
                                    )
                                "
                            >
                                <option
                                    v-if="isParcelBoxAvailable"
                                    :selected="isPickupStation"
                                    value="PACKSTATION"
                                >
                                    {{
                                        $translate(
                                            "Ceres::Template.addressPackingStation"
                                        )
                                    }}
                                </option>
                                <option
                                    v-if="isPostOfficeAvailable"
                                    :selected="isPostOffice"
                                    value="POSTFILIALE"
                                >
                                    {{
                                        $translate(
                                            "Ceres::Template.addressPostOffice"
                                        )
                                    }}
                                </option>
                            </select>
                            <label for="'address1' + _uid">{{
                                $translate(
                                    "Ceres::Template.addressPickupLocation"
                                )
                            }}</label>
                        </div>
                    </div>

                    <!-- Packstationsnummer, Filialnummer -->
                    <div class="col-12 col-sm-4">
                        <div
                            class="input-unit"
                            data-model="address2"
                            data-validate="text"
                        >
                            <input
                                :id="'txtNumber' + _uid"
                                :value="value.address2"
                                autocomplete="address-line2"
                                inputmode="text"
                                maxlength="30"
                                name="housenumber"
                                type="text"
                                @input="
                                    emitInputEvent(
                                        'address2',
                                        $event.target.value
                                    )
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label
                                v-if="isPickupStation"
                                :for="'txtNumber' + _uid"
                                >{{
                                    $translate(
                                        "Ceres::Template.addressPackingStationNumber"
                                    )
                                }}*</label
                            >
                            <label v-if="isPostOffice" :for="'txtNumber' + _uid"
                                >{{
                                    $translate(
                                        "Ceres::Template.addressPostOfficeNumber"
                                    )
                                }}*</label
                            >
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="row">
                    <!-- PostNummer -->
                    <div class="col-12 col-sm-6">
                        <div
                            class="input-unit"
                            data-model="postNumber"
                            data-validate="text"
                        >
                            <input
                                :id="'postnumber' + _uid"
                                :value="value.postNumber"
                                data-testing="packing-station-de-postnumber"
                                inputmode="text"
                                maxlength="30"
                                name="postnumber"
                                type="text"
                                @input="
                                    emitInputEvent(
                                        'postNumber',
                                        $event.target.value
                                    )
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'postnumber' + _uid"
                                >{{
                                    $translate(
                                        "Ceres::Template.addressPostNummer"
                                    )
                                }}*</label
                            >
                        </div>
                    </div>

                    <div
                        v-if="
                            isInOptionalFields(
                                'de',
                                'delivery_address.address4'
                            )
                        "
                        class="col-12 col-sm-6"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'delivery_address.address4'
                                )
                            "
                            class="input-unit"
                            data-model="address4"
                        >
                            <input
                                :id="'decorateAddress1' + _uid"
                                :value="value.address4"
                                inputmode="text"
                                maxlength="30"
                                name="decorateAddress"
                                type="text"
                                @input="
                                    emitInputEvent(
                                        'address4',
                                        $event.target.value
                                    )
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'decorateAddress1' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressAdditionalAddress2",
                                        "de",
                                        "delivery_address.address4"
                                    )
                                }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-sm-4">
                <div
                    class="input-unit"
                    data-model="postalCode"
                    data-validate="postalCode"
                >
                    <input
                        :id="'txtZip' + _uid"
                        :value="value.postalCode"
                        data-testing="packing-station-de-postalcode"
                        inputmode="numeric"
                        maxlength="4"
                        name="zip"
                        type="text"
                        minlength="4"
                        @input="
                            emitInputEvent('postalCode', $event.target.value)
                        "
                        @keypress="onlyNumbers('postalCode', _uid, $event)"
                    />
                    <label :for="'txtZip' + _uid"
                        >{{ $translate("Ceres::Template.addressZip") }}*</label
                    >
                    <div
                        :id="'errTxtZip' + _uid"
                        :ref="'errTxtZip' + _uid"
                        class="errmsg text-danger position-absolute small mt-1"
                        style="display: none"
                    >
                        {{
                            $translate("GonserDT::Template.checkoutOnlyNumbers")
                        }}
                    </div>
                </div>
            </div>

            <div class="col-12 col-sm-4">
                <div class="input-unit" data-model="town" data-validate="text">
                    <input
                        :id="'txtPlace' + _uid"
                        :value="value.town"
                        data-testing="packing-station-de-town"
                        inputmode="text"
                        maxlength="30"
                        name="town"
                        type="text"
                        @input="emitInputEvent('town', $event.target.value)"
                        @keypress="filterCharacters($event)"
                    />
                    <label :for="'txtPlace' + _uid"
                        >{{
                            $translate("Ceres::Template.addressPlace")
                        }}*</label
                    >
                </div>
            </div>

            <div class="col-12 col-sm-4" data-testing="address-country-select">
                <country-select
                    :address-type="addressType"
                    :optional-address-fields="optionalAddressFields"
                    :required-address-fields="requiredAddressFields"
                    :specificCountryIds="[4, 34]"
                    :selected-country-id="value.countryId"
                    :selected-state-id="value.stateId"
                    @country-changed="onSelectedCountryChanged($event)"
                    @state-changed="emitInputEvent('stateId', $event)"
                >
                </country-select>
            </div>

            <slot name="custom-address-fields"></slot>

            <!-- MailInput -->
            <div class="col-12">
                <hr class="mt-0" />
                <div class="row">
                    <div
                        v-if="
                            isInOptionalFields('de', 'delivery_address.email')
                        "
                        class="col-12"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'delivery_address.email'
                                )
                            "
                            class="input-unit"
                            data-model="email"
                        >
                            <input
                                :id="'email' + _uid"
                                :value="value.email"
                                data-testing="packing-station-de-email-input"
                                inputmode="email"
                                maxlength="30"
                                name="email"
                                type="mail"
                                @input="
                                    emitInputEvent('email', $event.target.value)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'email' + _uid">{{
                                transformTranslation(
                                    "Ceres::Template.addressMail",
                                    "de",
                                    "delivery_address.email"
                                )
                            }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <!-- BillingAddressDE -->
        <template v-else-if="localeToShow == 'DE' && addressType === '1' && isMobile">
            <div class="col-12">
                <div class="row">
                    <div
                        v-if="
                            isInOptionalFields(
                                'de',
                                'billing_address.salutation'
                            )
                        "
                        class="col-12 col-sm-4"
                    >
                        <div
                            v-validate="
                                isInRequiredFields(
                                    'de',
                                    'billing_address.salutation'
                                )
                            "
                            class="input-unit"
                        >
                            <salutation-select
                                :id="'txtSalutation' + _uid"
                                :address-data="value"
                                :address-type="addressType"
                                :default-salutation="defaultSalutation"
                                :enabled-address-fields="optionalAddressFields"
                                @input="
                                    emitInputEvent($event.field, $event.value)
                                "
                            ></salutation-select>
                            <label :for="'txtSalutation' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressSalutation",
                                        "de",
                                        "billing_address.salutation"
                                    )
                                }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="row">
                    <div
                        v-if="
                            (isInOptionalFields(
                                'de',
                                'billing_address.salutation'
                            ) &&
                                value.gender === 'company') ||
                            (isInOptionalFields(
                                'de',
                                'billing_address.name1'
                            ) &&
                                !isInOptionalFields(
                                    'de',
                                    'billing_address.salutation'
                                ))
                        "
                        class="col-12 col-sm-6"
                    >
                        <div
                            class="input-unit"
                            :class="{ 'error-without-z': isCompanyValid1===false, 'success-without-z': isCompanyValid1===true }"
                            data-model="name1"
                            data-validate="text"
                        >
                            <input
                                :id="'txtCompany' + _uid"
                                :value="value.name1"
                                data-autofocus
                                data-testing="billing-address-de-company"
                                inputmode="text"
                                maxlength="30"
                                name="company"
                                type="text"
                                @input="
                                    emitInputEvent('name1', $event.target.value);
                                    clearTimer('C1');
                                    setTimer('C1',()=>{isAddressEmpty($event.target.value, 'company', 1)});
                                "
                                @blur="
                                        clearTimer('C1');
                                        isAddressEmpty($event.target.value, 'company', 1)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtCompany' + _uid"
                                >{{
                                    $translate(
                                        "Ceres::Template.addressCompany"
                                    )
                                }}*</label
                            >
                        </div>
                    </div>

                    <div class="col-12 col-sm-6">
                        <vat-id
                            :is-required="
                                isInRequiredFields(
                                    'de',
                                    'billing_address.vatNumber'
                                )
                            "
                            :selected-country-id="value.countryId"
                            :show-input="
                                (isInOptionalFields(
                                    'de',
                                    'billing_address.salutation'
                                ) &&
                                    value.gender === 'company' &&
                                    isInOptionalFields(
                                        'de',
                                        'billing_address.vatNumber'
                                    )) ||
                                (!isInOptionalFields(
                                    'de',
                                    'billing_address.salutation'
                                ) &&
                                    isInOptionalFields(
                                        'de',
                                        'billing_address.name1'
                                    ) &&
                                    isInOptionalFields(
                                        'de',
                                        'billing_address.vatNumber'
                                    ))
                            "
                            :value="value.vatNumber || ''"
                            @input="emitInputEvent('vatNumber', $event)"
                        >
                        </vat-id>
                    </div>
                </div>
            </div>

            <div class="col-12" data-testing="billing-address-de-name-inputs">
                <div class="row">
                    <div
                        v-if="isInOptionalFields('de', 'billing_address.title')"
                        class="col-12 col-sm-4"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'billing_address.title'
                                )
                            "
                            class="input-unit"
                            data-model="title"
                        >
                            <input
                                :id="'txtTitle' + _uid"
                                :value="value.title"
                                data-autofocus
                                data-testing="billing-address-de-title"
                                inputmode="text"
                                maxlength="30"
                                name="title"
                                type="text"
                                @input="
                                    emitInputEvent('title', $event.target.value)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtTitle' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressTitle",
                                        "de",
                                        "billing_address.title"
                                    )
                                }}
                            </label>
                        </div>
                    </div>

                    <template
                        v-if="areNameFieldsShown('de', 'billing_address')"
                    >
                        <div class="col-12 col-sm-4">
                            <div
                                v-validate:text="
                                    areNameFieldsRequired(
                                        'de',
                                        'billing_address'
                                    )
                                "
                                class="input-unit"
                                :class="{ 'error-without-z': isFirstNameValid1===false, 'success-without-z': isFirstNameValid1===true }"
                                data-model="name2"
                            >
                                <input
                                    :id="'txtFirstName' + _uid"
                                    :value="value.name2"
                                    data-autofocus
                                    data-testing="billing-address-de-firstname"
                                    inputmode="text"
                                    maxlength="19"
                                    name="firstName"
                                    type="text"
                                    @input="
                                        let inputValue = $event.target.value;
                                        emitInputEvent(
                                            'name2',
                                            $event.target.value
                                        );
                                        clearTimer('FN1');
                                        setTimer('FN1',()=>{isAddressEmpty(inputValue, 'firstName', 1)});
                                    "
                                    @blur="
                                        clearTimer('FN1');
                                        isAddressEmpty($event.target.value, 'firstName', 1)
                                    "
                                    @keypress="filterCharacters($event)"
                                />
                                <label :for="'txtFirstName' + _uid"
                                    >{{
                                        $translate(
                                            "Ceres::Template.addressFirstName"
                                        )
                                    }}
                                    <template
                                        v-if="
                                            areNameFieldsRequired(
                                                'de',
                                                'billing_address'
                                            )
                                        "
                                        >*</template
                                    >
                                </label>
                            </div>
                        </div>
                        <div class="col-12 col-sm-4">
                            <div
                                v-validate:text="
                                    areNameFieldsRequired(
                                        'de',
                                        'billing_address'
                                    )
                                "
                                class="input-unit"
                                :class="{ 'error-without-z': isLastNameValid1===false, 'success-without-z': isLastNameValid1===true }"
                                data-model="name3"
                            >
                                <input
                                    :id="'txtLastName' + _uid"
                                    :value="value.name3"
                                    data-testing="billing-address-de-lastname"
                                    inputmode="text"
                                    maxlength="19"
                                    name="lastName"
                                    type="text"
                                    @input="
                                        let inputValue = $event.target.value;
                                        emitInputEvent(
                                            'name3',
                                            $event.target.value
                                        );
                                        clearTimer('LN1');
                                        setTimer('LN1',()=>{isAddressEmpty(inputValue, 'lastName', 1)});
                                    "
                                    @blur="
                                        clearTimer('LN1');
                                        isAddressEmpty($event.target.value, 'lastName', 1)
                                    "
                                    @keypress="filterCharacters($event)"
                                />
                                <label :for="'txtLastName' + _uid"
                                    >{{
                                        $translate(
                                            "Ceres::Template.addressLastName"
                                        )
                                    }}
                                    <template
                                        v-if="
                                            areNameFieldsRequired(
                                                'de',
                                                'billing_address'
                                            )
                                        "
                                        >*</template
                                    >
                                </label>
                            </div>
                        </div>
                    </template>

                    <div v-else class="col-12 col-sm-8">
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'billing_address.contactPerson'
                                )
                            "
                            class="input-unit"
                            data-model="contactPerson"
                        >
                            <input
                                :id="'txtContactPerson' + _uid"
                                :value="value.contactPerson"
                                inputmode="text"
                                maxlength="19"
                                name="lastName"
                                type="text"
                                @input="
                                    emitInputEvent(
                                        'contactPerson',
                                        $event.target.value
                                    )
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtContactPerson' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressContactPerson",
                                        "de",
                                        "billing_address.contactPerson"
                                    )
                                }}
                            </label>
                        </div>
                    </div>

                    <div
                        v-if="isInOptionalFields('de', 'billing_address.name4')"
                        class="col-12 col-sm-4"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'billing_address.name4'
                                )
                            "
                            class="input-unit"
                            data-model="name4"
                        >
                            <input
                                :id="'txtAdditionalName' + _uid"
                                :value="value.name4"
                                inputmode="text"
                                maxlength="30"
                                name="decorateName"
                                type="text"
                                @input="
                                    emitInputEvent('name4', $event.target.value)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtAdditionalName' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressAdditionalName",
                                        "de",
                                        "billing_address.name4"
                                    )
                                }}
                            </label>
                        </div>
                    </div>

                    <div
                        v-if="
                            isInOptionalFields('de', 'billing_address.birthday')
                        "
                        class="col-12 col-sm-4"
                    >
                        <div
                            v-validate:date="
                                isInRequiredFields(
                                    'de',
                                    'billing_address.birthday'
                                ) ||
                                (!!value.birthday && !!value.birthday.length)
                            "
                            class="input-unit"
                            data-model="birthday"
                        >
                            <input
                                :id="'txtBirthdate' + _uid"
                                :max="new Date().toISOString().split('T')[0]"
                                :placeholder="
                                    $translate(
                                        'Ceres::Template.addressBirthdatePlaceholder'
                                    )
                                "
                                :value="value.birthday"
                                min="1901-12-14"
                                name="birthday"
                                type="date"
                                @input="
                                    emitInputEvent(
                                        'birthday',
                                        $event.target.value
                                    )
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtBirthdate' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressBirthdate",
                                        "de",
                                        "billing_address.birthday"
                                    )
                                }}
                            </label>
                        </div>
                    </div>
                    <div
                        v-if="
                            isInOptionalFields(
                                'de',
                                'billing_address.phoneNumber'
                            )
                        "
                        class="col-12 col-sm-4"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'billing_address.phoneNumber'
                                )
                            "
                            class="input-unit"
                            data-model="telephone"
                        >
                            <input
                                :id="'txtTelephone' + _uid"
                                :value="value.telephone"
                                inputmode="tel"
                                maxlength="30"
                                name="telephone"
                                type="tel"
                                @input="
                                    emitInputEvent(
                                        'telephone',
                                        $event.target.value
                                    )
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtTelephone' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressTelephone",
                                        "de",
                                        "billing_address.phoneNumber"
                                    )
                                }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12" data-testing="billing-address-de-street-inputs">
                <div class="row">
                    <div class="col-12 col-sm-8">
                        <div
                            class="input-unit"
                            :class="{ 'error-without-z': isStreetNameValid1===false, 'success-without-z': isStreetNameValid1===true }"
                            data-model="address1"
                            data-validate="text"
                        >
                            <input
                                :id="'txtStreet' + _uid"
                                :value="value.address1"
                                autocomplete="address-line1"
                                data-testing="billing-address-de-street"
                                inputmode="text"
                                maxlength="30"
                                name="street"
                                type="text"
                                @input="
                                    let inputValue = $event.target.value;
                                    emitInputEvent(
                                        'address1',
                                        $event.target.value
                                    );
                                    clearTimer('SN1');
                                    setTimer('SN1',()=>{isAddressEmpty(inputValue, 'street', 1)});
                                "
                                @blur="
                                    clearTimer('SN1');
                                    isAddressEmpty($event.target.value, 'street', 1)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtStreet' + _uid"
                                >{{
                                    $translate("Ceres::Template.addressStreet")
                                }}*</label
                            >
                        </div>
                    </div>

                    <div class="col-12 col-sm-4">
                        <div
                            class="input-unit"
                            :class="{ 'error-without-z': isHouseNumberValid1===false, 'success-without-z': isHouseNumberValid1===true }"
                            data-model="address2"
                            data-validate="text"
                        >
                            <input
                                :id="'txtNumber' + _uid"
                                :value="value.address2"
                                autocomplete="address-line2"
                                data-testing="billing-address-de-house-number"
                                inputmode="text"
                                maxlength="30"
                                name="housenumber"
                                type="text"
                                @input="
                                    let inputValue = $event.target.value;
                                    emitInputEvent(
                                        'address2',
                                        $event.target.value
                                    );
                                    clearTimer('HN1');
                                    setTimer('HN1',()=>{isAddressEmpty(inputValue, 'houseNumber', 1)});
                                "
                                @blur="
                                    clearTimer('HN1');
                                    isAddressEmpty($event.target.value, 'houseNumber', 1)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtNumber' + _uid"
                                >{{
                                    $translate("Ceres::Template.addressNumber")
                                }}*</label
                            >
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="row">
                    <div
                        v-if="
                            isInOptionalFields('de', 'billing_address.address3')
                        "
                        class="col-12 col-sm-6"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'billing_address.address3'
                                )
                            "
                            class="input-unit"
                            data-model="address3"
                        >
                            <input
                                :id="'decorateAddress0' + _uid"
                                :value="value.address3"
                                inputmode="text"
                                maxlength="30"
                                name="decorateAddress"
                                type="text"
                                @input="
                                    emitInputEvent(
                                        'address3',
                                        $event.target.value
                                    )
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'decorateAddress0' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressAdditionalAddress1",
                                        "de",
                                        "billing_address.address3"
                                    )
                                }}
                            </label>
                        </div>
                    </div>

                    <div
                        v-if="
                            isInOptionalFields('de', 'billing_address.address4')
                        "
                        class="col-12 col-sm-6"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'billing_address.address4'
                                )
                            "
                            class="input-unit"
                            data-model="address4"
                        >
                            <input
                                :id="'decorateAddress1' + _uid"
                                :value="value.address4"
                                inputmode="text"
                                maxlength="30"
                                name="decorateAddress"
                                type="text"
                                @input="
                                    emitInputEvent(
                                        'address4',
                                        $event.target.value
                                    )
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'decorateAddress1' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressAdditionalAddress2",
                                        "de",
                                        "billing_address.address4"
                                    )
                                }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-sm-4">
                <div
                    class="input-unit"
                    :class="{ 'error-without-z': isPostalCodeValid1===false, 'success-without-z': isPostalCodeValid1===true }"
                    data-model="postalCode"
                    data-validate="postalCode"
                >
                    <input
                        class="postalCodeCustom"
                        :id="'txtZip' + _uid"
                        :value="value.postalCode"
                        data-testing="billing-address-de-zip"
                        inputmode="numeric"
                        maxlength="4"
                        name="zip"
                        type="text"
                        pattern=".{4,4}"
                        @input="
                            let inputValue = $event.target.value;
                            emitInputEvent('postalCode', $event.target.value);
                            clearTimer('ZIP1');
                            setTimer('ZIP1',()=>{validatePostalCode(inputValue, 1)});
                        "
                        @blur="
                            clearTimer('ZIP1');
                            validatePostalCode($event.target.value, 1)
                        "
                        @keypress="onlyNumbers('postalCode', _uid, $event)"
                    />
                    <label :for="'txtZip' + _uid">
                        {{ $translate("Ceres::Template.addressZip") }}*
                    </label>

                    <div
                        :id="'errTxtZip' + _uid"
                        :ref="'errTxtZip' + _uid"
                        class="errmsg text-danger position-absolute small mt-1"
                        style="display: none"
                    >
                        {{
                            $translate("GonserDT::Template.checkoutOnlyNumbers")
                        }}
                    </div>
                    <div class="errTxtZipLength bg-warning p-3">
                        {{ $translate("GonserDT::Template.checkoutZipLength") }}
                    </div>
                </div>
            </div>

            <div class="col-12 col-sm-4">
                <div class="input-unit" 
                    :class="{'error-without-z': isTownValid1===false, 'success-without-z': isTownValid1===true}"
                    data-model="town" 
                    data-validate="text"
                >
                    <input
                        :id="'txtPlace' + _uid"
                        :value="value.town"
                        data-testing="billing-address-de-town"
                        inputmode="text"
                        maxlength="30"
                        name="town"
                        type="text"
                        @input="
                            let inputValue = $event.target.value;
                            emitInputEvent('town', $event.target.value);
                            clearTimer('T1');
                            setTimer('T1',()=>{isAddressEmpty(inputValue, 'town', 1)});
                        "
                        @blur="
                            clearTimer('T1');
                            isAddressEmpty($event.target.value, 'town', 1)
                            "
                        @keypress="filterCharacters($event)"
                    />
                    <label :for="'txtPlace' + _uid"
                        >{{
                            $translate("Ceres::Template.addressPlace")
                        }}*</label
                    >
                </div>
            </div>

            <div class="col-12 col-sm-4" data-testing="address-country-select">
                <country-select
                    :address-type="addressType"
                    :optional-address-fields="optionalAddressFields"
                    :required-address-fields="requiredAddressFields"
                    :specificCountryIds="[4, 34]"
                    :selected-country-id="value.countryId"
                    :selected-state-id="value.stateId"
                    @country-changed="onSelectedCountryChanged($event)"
                    @state-changed="emitInputEvent('stateId', $event)"
                >
                </country-select>
            </div>

            <slot name="custom-address-fields"></slot>

            <!-- MailInput -->
            <div class="col-12">
                <hr class="mt-0" />
                <div class="row">
                    <div
                        v-if="isInOptionalFields('de', 'billing_address.email')"
                        class="col-12"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'billing_address.email'
                                )
                            "
                            class="input-unit"
                            data-model="email"
                        >
                            <input
                                :id="'email' + _uid"
                                :value="value.email"
                                data-testing="billing-address-de-email-input"
                                inputmode="email"
                                maxlength="30"
                                name="email"
                                type="mail"
                                @input="
                                    emitInputEvent('email', $event.target.value)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'email' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressMail",
                                        "de",
                                        "billing_address.email"
                                    )
                                }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="localeToShow == 'DE' && addressType === '1' && !isMobile">
            <div class="col-12">
                <div class="row">
                    <div
                        v-if="
                            isInOptionalFields(
                                'de',
                                'billing_address.salutation'
                            )
                        "
                        class="col-12 col-sm-4"
                    >
                        <div
                            v-validate="
                                isInRequiredFields(
                                    'de',
                                    'billing_address.salutation'
                                )
                            "
                            class="input-unit"
                        >
                            <salutation-select
                                :id="'txtSalutation' + _uid"
                                :address-data="value"
                                :address-type="addressType"
                                :default-salutation="defaultSalutation"
                                :enabled-address-fields="optionalAddressFields"
                                @input="
                                    emitInputEvent($event.field, $event.value)
                                "
                            ></salutation-select>
                            <label :for="'txtSalutation' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressSalutation",
                                        "de",
                                        "billing_address.salutation"
                                    )
                                }}
                            </label>
                        </div>
                    </div>
                    <div
                        v-if="isInOptionalFields('de', 'billing_address.title')"
                        class="col-12 col-sm-4"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'billing_address.title'
                                )
                            "
                            class="input-unit"
                            data-model="title"
                        >
                            <input
                                :id="'txtTitle' + _uid"
                                :value="value.title"
                                data-autofocus
                                data-testing="billing-address-de-title"
                                inputmode="text"
                                maxlength="30"
                                name="title"
                                type="text"
                                @input="
                                    emitInputEvent('title', $event.target.value)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtTitle' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressTitle",
                                        "de",
                                        "billing_address.title"
                                    )
                                }}
                            </label>
                        </div>
                    </div>

                    <template
                        v-if="areNameFieldsShown('de', 'billing_address')"
                    >
                        <div class="col-12 col-sm-4">
                            <div
                                v-validate:text="
                                    areNameFieldsRequired(
                                        'de',
                                        'billing_address'
                                    )
                                "
                                class="input-unit"
                                :class="{ 'error-without-z': isFirstNameValid1===false, 'success-without-z': isFirstNameValid1===true }"
                                data-model="name2"
                            >
                                <input
                                    :id="'txtFirstName' + _uid"
                                    :value="value.name2"
                                    data-autofocus
                                    data-testing="billing-address-de-firstname"
                                    inputmode="text"
                                    maxlength="19"
                                    name="firstName"
                                    type="text"
                                    @input="
                                        let inputValue = $event.target.value;
                                        emitInputEvent(
                                            'name2',
                                            $event.target.value
                                        );
                                        clearTimer('FN1');
                                        setTimer('FN1',()=>{isAddressEmpty(inputValue, 'firstName', 1)});
                                    "
                                    @blur="
                                        clearTimer('FN1');
                                        isAddressEmpty($event.target.value, 'firstName', 1)
                                    "
                                    @keypress="filterCharacters($event)"
                                />
                                <label :for="'txtFirstName' + _uid"
                                    >{{
                                        $translate(
                                            "Ceres::Template.addressFirstName"
                                        )
                                    }}
                                    <template
                                        v-if="
                                            areNameFieldsRequired(
                                                'de',
                                                'billing_address'
                                            )
                                        "
                                        >*</template
                                    >
                                </label>
                            </div>
                        </div>
                        <div class="col-12 col-sm-4">
                            <div
                                v-validate:text="
                                    areNameFieldsRequired(
                                        'de',
                                        'billing_address'
                                    )
                                "
                                class="input-unit"
                                :class="{ 'error-without-z': isLastNameValid1===false, 'success-without-z': isLastNameValid1===true }"
                                data-model="name3"
                            >
                                <input
                                    :id="'txtLastName' + _uid"
                                    :value="value.name3"
                                    data-testing="billing-address-de-lastname"
                                    inputmode="text"
                                    maxlength="19"
                                    name="lastName"
                                    type="text"
                                    @input="
                                        let inputValue = $event.target.value;
                                        emitInputEvent(
                                            'name3',
                                            $event.target.value
                                        );
                                        clearTimer('LN1');
                                        setTimer('LN1',()=>{isAddressEmpty(inputValue, 'lastName', 1)});
                                    "
                                    @blur="
                                        clearTimer('LN1');
                                        isAddressEmpty($event.target.value, 'lastName', 1)
                                    "
                                    @keypress="filterCharacters($event)"
                                />
                                <label :for="'txtLastName' + _uid"
                                    >{{
                                        $translate(
                                            "Ceres::Template.addressLastName"
                                        )
                                    }}
                                    <template
                                        v-if="
                                            areNameFieldsRequired(
                                                'de',
                                                'billing_address'
                                            )
                                        "
                                        >*</template
                                    >
                                </label>
                            </div>
                        </div>
                    </template>

                    <div v-else class="col-12 col-sm-8">
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'billing_address.contactPerson'
                                )
                            "
                            class="input-unit"
                            data-model="contactPerson"
                        >
                            <input
                                :id="'txtContactPerson' + _uid"
                                :value="value.contactPerson"
                                inputmode="text"
                                maxlength="19"
                                name="lastName"
                                type="text"
                                @input="
                                    emitInputEvent(
                                        'contactPerson',
                                        $event.target.value
                                    )
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtContactPerson' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressContactPerson",
                                        "de",
                                        "billing_address.contactPerson"
                                    )
                                }}
                            </label>
                        </div>
                    </div>

                    <div
                        v-if="isInOptionalFields('de', 'billing_address.name4')"
                        class="col-12 col-sm-4"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'billing_address.name4'
                                )
                            "
                            class="input-unit"
                            data-model="name4"
                        >
                            <input
                                :id="'txtAdditionalName' + _uid"
                                :value="value.name4"
                                inputmode="text"
                                maxlength="30"
                                name="decorateName"
                                type="text"
                                @input="
                                    emitInputEvent('name4', $event.target.value)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtAdditionalName' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressAdditionalName",
                                        "de",
                                        "billing_address.name4"
                                    )
                                }}
                            </label>
                        </div>
                    </div>

                    <div
                        v-if="
                            isInOptionalFields('de', 'billing_address.birthday')
                        "
                        class="col-12 col-sm-4"
                    >
                        <div
                            v-validate:date="
                                isInRequiredFields(
                                    'de',
                                    'billing_address.birthday'
                                ) ||
                                (!!value.birthday && !!value.birthday.length)
                            "
                            class="input-unit"
                            data-model="birthday"
                        >
                            <input
                                :id="'txtBirthdate' + _uid"
                                :max="new Date().toISOString().split('T')[0]"
                                :placeholder="
                                    $translate(
                                        'Ceres::Template.addressBirthdatePlaceholder'
                                    )
                                "
                                :value="value.birthday"
                                min="1901-12-14"
                                name="birthday"
                                type="date"
                                @input="
                                    emitInputEvent(
                                        'birthday',
                                        $event.target.value
                                    )
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtBirthdate' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressBirthdate",
                                        "de",
                                        "billing_address.birthday"
                                    )
                                }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="row">
                    <div
                        v-if="
                            (isInOptionalFields(
                                'de',
                                'billing_address.salutation'
                            ) &&
                                value.gender === 'company') ||
                            (isInOptionalFields(
                                'de',
                                'billing_address.name1'
                            ) &&
                                !isInOptionalFields(
                                    'de',
                                    'billing_address.salutation'
                                ))
                        "
                        class="col-12 col-sm-6"
                    >
                        <div
                            class="input-unit"
                            :class="{ 'error-without-z': isCompanyValid1===false, 'success-without-z': isCompanyValid1===true }"
                            data-model="name1"
                            data-validate="text"
                        >
                            <input
                                :id="'txtCompany' + _uid"
                                :value="value.name1"
                                data-autofocus
                                data-testing="billing-address-de-company"
                                inputmode="text"
                                maxlength="30"
                                name="company"
                                type="text"
                                @input="
                                    emitInputEvent('name1', $event.target.value);
                                    clearTimer('C1');
                                    setTimer('C1',()=>{isAddressEmpty($event.target.value, 'company', 1)});
                                "
                                @blur="
                                        clearTimer('C1');
                                        isAddressEmpty($event.target.value, 'company', 1)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtCompany' + _uid"
                                >{{
                                    $translate(
                                        "Ceres::Template.addressCompany"
                                    )
                                }}*</label
                            >
                        </div>
                    </div>

                    <div class="col-12 col-sm-6">
                        <vat-id
                            :is-required="
                                isInRequiredFields(
                                    'de',
                                    'billing_address.vatNumber'
                                )
                            "
                            :selected-country-id="value.countryId"
                            :show-input="
                                (isInOptionalFields(
                                    'de',
                                    'billing_address.salutation'
                                ) &&
                                    value.gender === 'company' &&
                                    isInOptionalFields(
                                        'de',
                                        'billing_address.vatNumber'
                                    )) ||
                                (!isInOptionalFields(
                                    'de',
                                    'billing_address.salutation'
                                ) &&
                                    isInOptionalFields(
                                        'de',
                                        'billing_address.name1'
                                    ) &&
                                    isInOptionalFields(
                                        'de',
                                        'billing_address.vatNumber'
                                    ))
                            "
                            :value="value.vatNumber || ''"
                            @input="emitInputEvent('vatNumber', $event)"
                        >
                        </vat-id>
                    </div>
                </div>
            </div>

            <div class="col-12" data-testing="billing-address-de-name-inputs">
                <div class="row">
                    <div class="col-6" data-testing="billing-address-de-street-inputs">
                        <div
                            class="input-unit"
                            :class="{ 'error-without-z': isStreetNameValid1===false, 'success-without-z': isStreetNameValid1===true }"
                            data-model="address1"
                            data-validate="text"
                        >
                            <input
                                :id="'txtStreet' + _uid"
                                :value="value.address1"
                                autocomplete="address-line1"
                                data-testing="billing-address-de-street"
                                inputmode="text"
                                maxlength="30"
                                name="street"
                                type="text"
                                @input="
                                    let inputValue = $event.target.value;
                                    emitInputEvent(
                                        'address1',
                                        $event.target.value
                                    );
                                    clearTimer('SN1');
                                    setTimer('SN1',()=>{isAddressEmpty(inputValue, 'street', 1)});
                                "
                                @blur="
                                    clearTimer('SN1');
                                    isAddressEmpty($event.target.value, 'street', 1)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtStreet' + _uid"
                                >{{
                                    $translate("Ceres::Template.addressStreet")
                                }}*</label
                            >
                        </div>
                    </div>
                    <div class="col-2">
                        <div
                            class="input-unit"
                            :class="{ 'error-without-z': isHouseNumberValid1===false, 'success-without-z': isHouseNumberValid1===true }"
                            data-model="address2"
                            data-validate="text"
                        >
                            <input
                                :id="'txtNumber' + _uid"
                                :value="value.address2"
                                autocomplete="address-line2"
                                data-testing="billing-address-de-house-number"
                                inputmode="text"
                                maxlength="30"
                                name="housenumber"
                                type="text"
                                @input="
                                    let inputValue = $event.target.value;
                                    emitInputEvent(
                                        'address2',
                                        $event.target.value
                                    );
                                    clearTimer('HN1');
                                    setTimer('HN1',()=>{isAddressEmpty(inputValue, 'houseNumber', 1)});
                                "
                                @blur="
                                    clearTimer('HN1');
                                    isAddressEmpty($event.target.value, 'houseNumber', 1)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtNumber' + _uid"
                                >{{
                                    $translate("Ceres::Template.addressNumber")
                                }}*</label
                            >
                        </div>
                    </div>
                    <div
                        v-if="
                            isInOptionalFields(
                                'de',
                                'billing_address.phoneNumber'
                            )
                        "
                        class="col-4"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'billing_address.phoneNumber'
                                )
                            "
                            class="input-unit"
                            data-model="telephone"
                        >
                            <input
                                :id="'txtTelephone' + _uid"
                                :value="value.telephone"
                                inputmode="tel"
                                maxlength="30"
                                name="telephone"
                                type="tel"
                                @input="
                                    emitInputEvent(
                                        'telephone',
                                        $event.target.value
                                    )
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtTelephone' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressTelephone",
                                        "de",
                                        "billing_address.phoneNumber"
                                    )
                                }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="row">
                    <div
                        v-if="
                            isInOptionalFields('de', 'billing_address.address3')
                        "
                        class="col-12 col-sm-6"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'billing_address.address3'
                                )
                            "
                            class="input-unit"
                            data-model="address3"
                        >
                            <input
                                :id="'decorateAddress0' + _uid"
                                :value="value.address3"
                                inputmode="text"
                                maxlength="30"
                                name="decorateAddress"
                                type="text"
                                @input="
                                    emitInputEvent(
                                        'address3',
                                        $event.target.value
                                    )
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'decorateAddress0' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressAdditionalAddress1",
                                        "de",
                                        "billing_address.address3"
                                    )
                                }}
                            </label>
                        </div>
                    </div>

                    <div
                        v-if="
                            isInOptionalFields('de', 'billing_address.address4')
                        "
                        class="col-12 col-sm-6"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'billing_address.address4'
                                )
                            "
                            class="input-unit"
                            data-model="address4"
                        >
                            <input
                                :id="'decorateAddress1' + _uid"
                                :value="value.address4"
                                inputmode="text"
                                maxlength="30"
                                name="decorateAddress"
                                type="text"
                                @input="
                                    emitInputEvent(
                                        'address4',
                                        $event.target.value
                                    )
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'decorateAddress1' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressAdditionalAddress2",
                                        "de",
                                        "billing_address.address4"
                                    )
                                }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-sm-4">
                <div
                    class="input-unit"
                    :class="{ 'error-without-z': isPostalCodeValid1===false, 'success-without-z': isPostalCodeValid1===true }"
                    data-model="postalCode"
                    data-validate="postalCode"
                >
                    <input
                        class="postalCodeCustom"
                        :id="'txtZip' + _uid"
                        :value="value.postalCode"
                        data-testing="billing-address-de-zip"
                        inputmode="numeric"
                        maxlength="4"
                        name="zip"
                        type="text"
                        pattern=".{4,4}"
                        @input="
                            let inputValue = $event.target.value;
                            emitInputEvent('postalCode', $event.target.value);
                            clearTimer('ZIP1');
                            setTimer('ZIP1',()=>{validatePostalCode(inputValue, 1)});
                        "
                        @blur="
                            clearTimer('ZIP1');
                            validatePostalCode($event.target.value, 1)
                        "
                        @keypress="onlyNumbers('postalCode', _uid, $event)"
                    />
                    <label :for="'txtZip' + _uid">
                        {{ $translate("Ceres::Template.addressZip") }}*
                    </label>

                    <div
                        :id="'errTxtZip' + _uid"
                        :ref="'errTxtZip' + _uid"
                        class="errmsg text-danger position-absolute small mt-1"
                        style="display: none"
                    >
                        {{
                            $translate("GonserDT::Template.checkoutOnlyNumbers")
                        }}
                    </div>
                    <div class="errTxtZipLength bg-warning p-3">
                        {{ $translate("GonserDT::Template.checkoutZipLength") }}
                    </div>
                </div>
            </div>

            <div class="col-12 col-sm-4">
                <div class="input-unit" 
                    :class="{'error-without-z': isTownValid1===false, 'success-without-z': isTownValid1===true}"
                    data-model="town" 
                    data-validate="text"
                >
                    <input
                        :id="'txtPlace' + _uid"
                        :value="value.town"
                        data-testing="billing-address-de-town"
                        inputmode="text"
                        maxlength="30"
                        name="town"
                        type="text"
                        @input="
                            let inputValue = $event.target.value;
                            emitInputEvent('town', $event.target.value);
                            clearTimer('T1');
                            setTimer('T1',()=>{isAddressEmpty(inputValue, 'town', 1)});
                        "
                        @blur="
                            clearTimer('T1');
                            isAddressEmpty($event.target.value, 'town', 1)
                            "
                        @keypress="filterCharacters($event)"
                    />
                    <label :for="'txtPlace' + _uid"
                        >{{
                            $translate("Ceres::Template.addressPlace")
                        }}*</label
                    >
                </div>
            </div>

            <div class="col-12 col-sm-4" data-testing="address-country-select">
                <country-select
                    :address-type="addressType"
                    :optional-address-fields="optionalAddressFields"
                    :required-address-fields="requiredAddressFields"
                    :specificCountryIds="[4, 34]"
                    :selected-country-id="value.countryId"
                    :selected-state-id="value.stateId"
                    @country-changed="onSelectedCountryChanged($event)"
                    @state-changed="emitInputEvent('stateId', $event)"
                >
                </country-select>
            </div>

            <slot name="custom-address-fields"></slot>

            <!-- MailInput -->
            <div class="col-12">
                <hr class="mt-0" />
                <div class="row">
                    <div
                        v-if="isInOptionalFields('de', 'billing_address.email')"
                        class="col-12"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'billing_address.email'
                                )
                            "
                            class="input-unit"
                            data-model="email"
                        >
                            <input
                                :id="'email' + _uid"
                                :value="value.email"
                                data-testing="billing-address-de-email-input"
                                inputmode="email"
                                maxlength="30"
                                name="email"
                                type="mail"
                                @input="
                                    emitInputEvent('email', $event.target.value)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'email' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressMail",
                                        "de",
                                        "billing_address.email"
                                    )
                                }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <!-- BillingAddressGB -->
        <template v-else-if="localeToShow == 'GB' && addressType === '1'">
            <div class="col-12">
                <div class="row">
                    <div
                        v-if="
                            isInOptionalFields(
                                'gb',
                                'billing_address.salutation'
                            )
                        "
                        class="col-12 col-sm-4"
                    >
                        <div
                            v-validate="
                                isInRequiredFields(
                                    'gb',
                                    'billing_address.salutation'
                                )
                            "
                            class="input-unit"
                        >
                            <salutation-select
                                :id="'txtSalutation' + _uid"
                                :address-data="value"
                                :address-type="addressType"
                                :enabled-address-fields="optionalAddressFields"
                                @input="
                                    emitInputEvent($event.field, $event.value)
                                "
                            ></salutation-select>
                            <label :for="'txtSalutation' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressSalutation",
                                        "gb",
                                        "billing_address.salutation"
                                    )
                                }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="row">
                    <div
                        v-if="
                            (isInOptionalFields(
                                'gb',
                                'billing_address.salutation'
                            ) &&
                                value.gender === 'company') ||
                            (isInOptionalFields(
                                'gb',
                                'billing_address.name1'
                            ) &&
                                !isInOptionalFields(
                                    'gb',
                                    'billing_address.salutation'
                                ))
                        "
                        class="col-12 col-sm-6"
                    >
                        <div
                            class="input-unit"
                            data-model="name1"
                            data-validate="text"
                        >
                            <input
                                :id="'txtCompany' + _uid"
                                :value="value.name1"
                                data-autofocus
                                inputmode="text"
                                maxlength="30"
                                name="company"
                                type="text"
                                @input="
                                    emitInputEvent('name1', $event.target.value)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtCompany' + _uid">
                                {{
                                    $translate(
                                        "Ceres::Template.addressCompany"
                                    )
                                }}*
                            </label>
                        </div>
                    </div>

                    <div class="col-12 col-sm-6">
                        <vat-id
                            :is-required="
                                isInRequiredFields(
                                    'gb',
                                    'billing_address.vatNumber'
                                )
                            "
                            :selected-country-id="value.countryId"
                            :show-input="
                                (isInOptionalFields(
                                    'gb',
                                    'billing_address.salutation'
                                ) &&
                                    value.gender === 'company' &&
                                    isInOptionalFields(
                                        'gb',
                                        'billing_address.vatNumber'
                                    )) ||
                                (!isInOptionalFields(
                                    'gb',
                                    'billing_address.salutation'
                                ) &&
                                    isInOptionalFields(
                                        'gb',
                                        'billing_address.name1'
                                    ) &&
                                    isInOptionalFields(
                                        'gb',
                                        'billing_address.vatNumber'
                                    ))
                            "
                            :value="value.vatNumber || ''"
                            @input="emitInputEvent('vatNumber', $event)"
                        >
                        </vat-id>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="row">
                    <div
                        v-if="isInOptionalFields('gb', 'billing_address.title')"
                        class="col-12 col-sm-4"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'gb',
                                    'billing_address.title'
                                )
                            "
                            class="input-unit"
                            data-model="title"
                        >
                            <input
                                :id="'txtTitle' + _uid"
                                :value="value.title"
                                data-autofocus
                                inputmode="text"
                                maxlength="30"
                                name="title"
                                type="text"
                                @input="
                                    emitInputEvent('title', $event.target.value)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtTitle' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressTitle",
                                        "gb",
                                        "billing_address.title"
                                    )
                                }}
                            </label>
                        </div>
                    </div>

                    <template
                        v-if="areNameFieldsShown('gb', 'billing_address')"
                    >
                        <div class="col-12 col-sm-4">
                            <div
                                v-validate:text="
                                    areNameFieldsRequired(
                                        'gb',
                                        'billing_address'
                                    )
                                "
                                class="input-unit"
                                data-model="name2"
                            >
                                <input
                                    :id="'txtFirstName' + _uid"
                                    :value="value.name2"
                                    data-autofocus
                                    data-model="name2"
                                    inputmode="text"
                                    maxlength="19"
                                    name="firstName"
                                    type="text"
                                    @input="
                                        emitInputEvent(
                                            'name2',
                                            $event.target.value
                                        )
                                    "
                                    @keypress="filterCharacters($event)"
                                />
                                <label :for="'txtFirstName' + _uid"
                                    >{{
                                        $translate(
                                            "Ceres::Template.addressFirstName"
                                        )
                                    }}
                                    <template
                                        v-if="
                                            areNameFieldsRequired(
                                                'gb',
                                                'billing_address'
                                            )
                                        "
                                        >*</template
                                    >
                                </label>
                            </div>
                        </div>

                        <div class="col-12 col-sm-4">
                            <div
                                v-validate:text="
                                    areNameFieldsRequired(
                                        'gb',
                                        'billing_address'
                                    )
                                "
                                class="input-unit"
                                data-model="name3"
                            >
                                <input
                                    :id="'txtLastName' + _uid"
                                    :value="value.name3"
                                    data-model="name3"
                                    inputmode="text"
                                    maxlength="19"
                                    name="lastName"
                                    type="text"
                                    @input="
                                        emitInputEvent(
                                            'name3',
                                            $event.target.value
                                        )
                                    "
                                    @keypress="filterCharacters($event)"
                                />
                                <label :for="'txtLastName' + _uid"
                                    >{{
                                        $translate(
                                            "Ceres::Template.addressLastName"
                                        )
                                    }}
                                    <template
                                        v-if="
                                            areNameFieldsRequired(
                                                'gb',
                                                'billing_address'
                                            )
                                        "
                                        >*</template
                                    >
                                </label>
                            </div>
                        </div>
                    </template>

                    <div v-else class="col-12 col-sm-8">
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'gb',
                                    'billing_address.contactPerson'
                                )
                            "
                            class="input-unit"
                            data-model="contactPerson"
                        >
                            <input
                                :id="'txtContactPerson' + _uid"
                                :value="value.contactPerson"
                                inputmode="text"
                                maxlength="19"
                                name="lastName"
                                type="text"
                                @input="
                                    emitInputEvent(
                                        'contactPerson',
                                        $event.target.value
                                    )
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtContactPerson' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressContactPerson",
                                        "gb",
                                        "billing_address.contactPerson"
                                    )
                                }}
                            </label>
                        </div>
                    </div>

                    <div
                        v-if="isInOptionalFields('gb', 'billing_address.name4')"
                        class="col-sm-4"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'gb',
                                    'billing_address.name4'
                                )
                            "
                            class="input-unit"
                            data-model="name4"
                        >
                            <input
                                :id="'txtAdditionalName' + _uid"
                                :value="value.name4"
                                inputmode="text"
                                maxlength="30"
                                name="decorateName"
                                type="text"
                                @input="
                                    emitInputEvent('name4', $event.target.value)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtAdditionalName' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressGBNameAffix",
                                        "gb",
                                        "billing_address.name4"
                                    )
                                }}
                            </label>
                        </div>
                    </div>

                    <div
                        v-if="
                            isInOptionalFields('gb', 'billing_address.birthday')
                        "
                        class="col-12 col-sm-4"
                    >
                        <div
                            v-validate:date="
                                isInRequiredFields(
                                    'gb',
                                    'billing_address.birthday'
                                ) ||
                                (!!value.birthday && !!value.birthday.length)
                            "
                            class="input-unit"
                            data-model="birthday"
                        >
                            <input
                                :id="'txtBirthdate' + _uid"
                                :max="new Date().toISOString().split('T')[0]"
                                :placeholder="
                                    $translate(
                                        'Ceres::Template.addressBirthdatePlaceholder'
                                    )
                                "
                                :value="value.birthday"
                                min="1901-12-14"
                                name="birthday"
                                type="date"
                                @input="
                                    emitInputEvent(
                                        'birthday',
                                        $event.target.value
                                    )
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtBirthdate' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressBirthdate",
                                        "gb",
                                        "billing_address.birthday"
                                    )
                                }}
                            </label>
                        </div>
                    </div>

                    <div
                        v-if="
                            isInOptionalFields(
                                'gb',
                                'billing_address.phoneNumber'
                            )
                        "
                        class="col-12 col-sm-4"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'gb',
                                    'billing_address.phoneNumber'
                                )
                            "
                            class="input-unit"
                            data-model="telephone"
                        >
                            <input
                                :id="'txtTelephone' + _uid"
                                :value="value.telephone"
                                inputmode="tel"
                                maxlength="30"
                                name="telephone"
                                type="tel"
                                @input="
                                    emitInputEvent(
                                        'telephone',
                                        $event.target.value
                                    )
                                "
                                @keypress="
                                    onlyNumbers('telephone', _uid, $event)
                                "
                            />
                            <label :for="'txtTelephone' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressTelephone",
                                        "gb",
                                        "billing_address.phoneNumber"
                                    )
                                }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="col-12"
                data-testing="invoice-addresses-street-select-gb"
            >
                <div class="row">
                    <div class="col-12 col-sm-12">
                        <div
                            class="input-unit"
                            data-model="address1"
                            data-validate="text"
                        >
                            <input
                                :id="'txtStreet' + _uid"
                                :value="value.address1"
                                autocomplete="address-line1"
                                inputmode="text"
                                maxlength="30"
                                name="street"
                                type="text"
                                @input="
                                    emitInputEvent(
                                        'address1',
                                        $event.target.value
                                    )
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtStreet' + _uid">
                                {{
                                    $translate(
                                        "Ceres::Template.addressENAddressLine1"
                                    )
                                }}*
                            </label>
                        </div>
                    </div>

                    <div
                        v-if="
                            isInOptionalFields('gb', 'billing_address.address2')
                        "
                        class="col-12 col-sm-12"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'gb',
                                    'billing_address.address2'
                                )
                            "
                            class="input-unit"
                            data-model="address2"
                        >
                            <input
                                :id="'txtNumber' + _uid"
                                :value="value.address2"
                                autocomplete="address-line2"
                                inputmode="text"
                                maxlength="30"
                                name="housenumber"
                                type="text"
                                @input="
                                    emitInputEvent(
                                        'address2',
                                        $event.target.value
                                    )
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtNumber' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressENAddressLine2",
                                        "gb",
                                        "billing_address.address2"
                                    )
                                }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="row">
                    <div
                        v-if="
                            isInOptionalFields('gb', 'billing_address.address3')
                        "
                        class="col-12 col-sm-12"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'gb',
                                    'billing_address.address3'
                                )
                            "
                            class="input-unit"
                            data-model="address3"
                        >
                            <input
                                :id="'decorateAddress0' + _uid"
                                :value="value.address3"
                                inputmode="text"
                                maxlength="30"
                                name="buildingName"
                                type="text"
                                @input="
                                    emitInputEvent(
                                        'address3',
                                        $event.target.value
                                    )
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'decorateAddress0' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressENAddressLine3",
                                        "gb",
                                        "billing_address.address3"
                                    )
                                }}
                            </label>
                        </div>
                    </div>

                    <div
                        v-if="
                            isInOptionalFields('gb', 'billing_address.address4')
                        "
                        class="col-12 col-sm-12"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'gb',
                                    'billing_address.address4'
                                )
                            "
                            class="input-unit"
                            data-model="address4"
                        >
                            <input
                                :id="'decorateAddress0' + _uid"
                                :value="value.address4"
                                inputmode="text"
                                maxlength="30"
                                name="buildingName"
                                type="text"
                                @input="
                                    emitInputEvent(
                                        'address4',
                                        $event.target.value
                                    )
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'decorateAddress0' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressENAddressLine4",
                                        "gb",
                                        "billing_address.address4"
                                    )
                                }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-sm-4">
                <div class="input-unit" data-model="town" data-validate="text">
                    <input
                        :id="'txtPlace' + _uid"
                        :value="value.town"
                        inputmode="text"
                        maxlength="30"
                        name="town"
                        type="text"
                        @input="emitInputEvent('town', $event.target.value)"
                        @keypress="filterCharacters($event)"
                    />
                    <label :for="'txtPlace' + _uid"
                        >{{
                            $translate("Ceres::Template.addressPlace")
                        }}*</label
                    >
                </div>
            </div>

            <div class="col-12 col-sm-4">
                <div
                    class="input-unit"
                    data-model="postalCode"
                    data-validate="postalCode"
                >
                    <input
                        :id="'txtZip' + _uid"
                        :value="value.postalCode"
                        inputmode="numeric"
                        maxlength="4"
                        name="zip"
                        type="text"
                        @input="
                            emitInputEvent('postalCode', $event.target.value)
                        "
                        @keypress="onlyNumbers('postalCode', _uid, $event)"
                        pattern=".{4,4}"
                    />
                    <label :for="'txtZip' + _uid"
                        >{{ $translate("Ceres::Template.addressZip") }}*</label
                    >
                    <div
                        :id="'errTxtZip' + _uid"
                        :ref="'errTxtZip' + _uid"
                        class="errmsg test3 text-danger position-absolute small mt-1"
                        style="display: none"
                    >
                        {{
                            $translate("GonserDT::Template.checkoutOnlyNumbers")
                        }}
                    </div>
                </div>
            </div>

            <div class="col-12 col-sm-4" data-testing="address-country-select">
                <country-select
                    :address-type="addressType"
                    :optional-address-fields="optionalAddressFields"
                    :required-address-fields="requiredAddressFields"
                    :specificCountryIds="[4, 34]"
                    :selected-country-id="value.countryId"
                    :selected-state-id="value.stateId"
                    @country-changed="onSelectedCountryChanged($event)"
                    @state-changed="emitInputEvent('stateId', $event)"
                >
                </country-select>
            </div>

            <slot name="custom-address-fields"></slot>

            <!-- MailInput -->
            <div class="col-12">
                <hr class="mt-0" />
                <div class="row">
                    <div
                        v-if="isInOptionalFields('gb', 'billing_address.email')"
                        class="col-12"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'gb',
                                    'billing_address.email'
                                )
                            "
                            class="input-unit"
                            data-model="email"
                        >
                            <input
                                :id="'email' + _uid"
                                :value="value.email"
                                data-testing="billing-address-gb-email-input"
                                inputmode="email"
                                name="email"
                                type="mail"
                                @input="
                                    emitInputEvent('email', $event.target.value)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'email' + _uid">{{
                                transformTranslation(
                                    "Ceres::Template.addressMail",
                                    "gb",
                                    "billing_address.email"
                                )
                            }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <!-- DeliveryAddressDE -->
        <template v-else-if="localeToShow == 'DE' && addressType === '2' && isMobile">
            <div class="col-12">
                <div class="row">
                    <div
                        v-if="
                            isInOptionalFields(
                                'de',
                                'delivery_address.salutation'
                            )
                        "
                        class="col-12"
                    >
                        <div
                            v-validate="
                                isInRequiredFields(
                                    'de',
                                    'delivery_address.salutation'
                                )
                            "
                            class="input-unit"
                        >
                            <salutation-select
                                :id="'txtSalutation' + _uid"
                                :address-data="value"
                                :address-type="addressType"
                                :enabled-address-fields="optionalAddressFields"
                                @input="
                                    emitInputEvent($event.field, $event.value)
                                "
                            ></salutation-select>
                            <label :for="'txtSalutation' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressSalutation",
                                        "de",
                                        "delivery_address.salutation"
                                    )
                                }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="row">
                    <div
                        v-if="
                            (isInOptionalFields(
                                'de',
                                'delivery_address.salutation'
                            ) &&
                                value.gender === 'company') ||
                            (isInOptionalFields(
                                'de',
                                'delivery_address.name1'
                            ) &&
                                !isInOptionalFields(
                                    'de',
                                    'delivery_address.salutation'
                                ))
                        "
                        class="col-12 col-sm-6"
                    >
                        <div
                            class="input-unit"
                            :class="{ 'error-without-z': isCompanyNameValid2===false, 'success-without-z': isCompanyNameValid2===true}"
                            data-model="name1"
                            data-validate="text"
                        >
                            <input
                                :id="'txtCompany' + _uid"
                                :value="value.name1"
                                data-autofocus
                                inputmode="text"
                                maxlength="30"
                                name="company"
                                type="text"
                                @input="
                                    emitInputEvent('name1', $event.target.value);
                                    clearTimer('C2');
                                    setTimer('C2',()=>{isAddressEmpty($event.target.value, 'company', 2)});
                                "
                                @blur="
                                    clearTimer('C2');
                                    isAddressEmpty($event.target.value, 'company', 2)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtCompany' + _uid"
                                >{{
                                    $translate(
                                        "Ceres::Template.addressCompany"
                                    )
                                }}*</label
                            >
                        </div>
                    </div>
                    <div class="col-12 col-sm-6">
                        <vat-id
                            :is-required="
                                isInRequiredFields(
                                    'de',
                                    'delivery_address.vatNumber'
                                )
                            "
                            :selected-country-id="value.countryId"
                            :show-input="
                                (isInOptionalFields(
                                    'de',
                                    'delivery_address.salutation'
                                ) &&
                                    value.gender === 'company' &&
                                    isInOptionalFields(
                                        'de',
                                        'delivery_address.vatNumber'
                                    )) ||
                                (!isInOptionalFields(
                                    'de',
                                    'delivery_address.salutation'
                                ) &&
                                    isInOptionalFields(
                                        'de',
                                        'delivery_address.name1'
                                    ) &&
                                    isInOptionalFields(
                                        'de',
                                        'delivery_address.vatNumber'
                                    ))
                            "
                            :value="value.vatNumber || ''"
                            @input="emitInputEvent('vatNumber', $event)"
                        >
                        </vat-id>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="row">
                    <div
                        v-if="
                            isInOptionalFields('de', 'delivery_address.title')
                        "
                        class="col-12 col-sm-4"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'delivery_address.title'
                                )
                            "
                            class="input-unit"
                            data-model="title"
                        >
                            <input
                                :id="'txtTitle' + _uid"
                                :value="value.title"
                                data-autofocus
                                inputmode="text"
                                maxlength="30"
                                name="title"
                                type="text"
                                @input="
                                    emitInputEvent('title', $event.target.value)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtTitle' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressTitle",
                                        "de",
                                        "delivery_address.title"
                                    )
                                }}
                            </label>
                        </div>
                    </div>

                    <template
                        v-if="areNameFieldsShown('de', 'delivery_address')"
                    >
                        <div class="col-12 col-sm-4">
                            <div
                                v-validate:text="
                                    areNameFieldsRequired(
                                        'de',
                                        'delivery_address'
                                    )
                                "
                                class="input-unit"
                                :class="{ 'error-without-z': isFirstNameValid2===false, 'success-without-z': isFirstNameValid2===true}"
                                data-model="name2"
                            >
                                <input
                                    :id="'txtFirstName' + _uid"
                                    :value="value.name2"
                                    data-autofocus
                                    data-testing="delivery-address-de-firstname"
                                    inputmode="text"
                                    maxlength="19"
                                    name="firstName"
                                    type="text"
                                    @input="
                                        let inputValue = $event.target.value;
                                        emitInputEvent(
                                            'name2',
                                            $event.target.value
                                        );
                                        clearTimer('FN2');;
                                        setTimer('FN2',()=>{isAddressEmpty(inputValue, 'firstName', 2)});
                                    "
                                    @blur="
                                        clearTimer('FN2');
                                        isAddressEmpty($event.target.value, 'firstName', 2)
                                    "
                                    @keypress="filterCharacters($event)"
                                />
                                <label :for="'txtFirstName' + _uid"
                                    >{{
                                        $translate(
                                            "Ceres::Template.addressFirstName"
                                        )
                                    }}
                                    <template
                                        v-if="
                                            areNameFieldsRequired(
                                                'de',
                                                'delivery_address'
                                            )
                                        "
                                        >*</template
                                    >
                                </label>
                            </div>
                        </div>

                        <div class="col-12 col-sm-4">
                            <div
                                v-validate:text="
                                    areNameFieldsRequired(
                                        'de',
                                        'delivery_address'
                                    )
                                "
                                class="input-unit"
                                :class="{ 'error-without-z': isLastNameValid2===false, 'success-without-z': isLastNameValid2===true}"
                                data-model="name3"
                            >
                                <input
                                    :id="'txtLastName' + _uid"
                                    :value="value.name3"
                                    data-testing="delivery-address-de-lastname"
                                    inputmode="text"
                                    maxlength="19"
                                    name="lastName"
                                    type="text"
                                    @input="
                                        let inputValue = $event.target.value;
                                        emitInputEvent(
                                            'name3',
                                            $event.target.value
                                        );
                                        clearTimer('LN2');
                                        setTimer('LN2',()=>{isAddressEmpty(inputValue, 'lastName', 2)});
                                    "
                                    @blur="
                                        clearTimer('LN2');
                                        isAddressEmpty($event.target.value, 'lastName', 2)
                                    "
                                    @keypress="filterCharacters($event)"
                                />
                                <label :for="'txtLastName' + _uid"
                                    >{{
                                        $translate(
                                            "Ceres::Template.addressLastName"
                                        )
                                    }}
                                    <template
                                        v-if="
                                            areNameFieldsRequired(
                                                'de',
                                                'delivery_address'
                                            )
                                        "
                                        >*</template
                                    >
                                </label>
                            </div>
                        </div>
                    </template>

                    <div v-else class="col-12 col-sm-8">
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'delivery_address.contactPerson'
                                )
                            "
                            class="input-unit"
                            data-model="contactPerson"
                        >
                            <input
                                :id="'txtContactPerson' + _uid"
                                :value="value.contactPerson"
                                inputmode="text"
                                maxlength="19"
                                name="lastName"
                                type="text"
                                @input="
                                    emitInputEvent(
                                        'contactPerson',
                                        $event.target.value
                                    )
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtContactPerson' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressContactPerson",
                                        "de",
                                        "delivery_address.contactPerson"
                                    )
                                }}
                            </label>
                        </div>
                    </div>

                    <div
                        v-if="
                            isInOptionalFields('de', 'delivery_address.name4')
                        "
                        class="col-12 col-sm-4"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'delivery_address.name4'
                                )
                            "
                            class="input-unit"
                            data-model="name4"
                        >
                            <input
                                :id="'txtAdditionalName' + _uid"
                                :value="value.name4"
                                inputmode="text"
                                maxlength="30"
                                name="decorateName"
                                type="text"
                                @input="
                                    emitInputEvent('name4', $event.target.value)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtAdditionalName' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressAdditionalName",
                                        "de",
                                        "delivery_address.name4"
                                    )
                                }}
                            </label>
                        </div>
                    </div>

                    <div
                        v-if="
                            isInOptionalFields(
                                'de',
                                'delivery_address.phoneNumber'
                            )
                        "
                        class="col-12 col-sm-4"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'delivery_address.phoneNumber'
                                )
                            "
                            class="input-unit"
                            data-model="telephone"
                        >
                            <input
                                :id="'txtTelephone' + _uid"
                                :value="value.telephone"
                                inputmode="tel"
                                maxlength="30"
                                name="telephone"
                                type="tel"
                                @input="
                                    emitInputEvent(
                                        'telephone',
                                        $event.target.value
                                    )
                                "
                                @keypress="
                                    onlyNumbers('telephone', _uid, $event)
                                "
                            />
                            <label :for="'txtTelephone' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressTelephone",
                                        "de",
                                        "delivery_address.phoneNumber"
                                    )
                                }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="isParcelOrOfficeAvailable" class="col-12">
                <div class="row">
                    <div class="col-12">
                        <input
                            :id="'showPickup' + _uid"
                            :checked="value.showPickupStation"
                            name="togglePickup"
                            type="checkbox"
                            @change="togglePickupStation($event.target.checked)"
                        />
                        <label :for="'showPickup' + _uid">{{
                            $translate("Ceres::Template.addressToPickupStation")
                        }}</label>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="row">
                    <div class="col-12 col-sm-8">
                        <div
                            class="input-unit"
                            :class="{ 'error-without-z': isStreetNameValid2===false, 'success-without-z': isStreetNameValid2===true}"
                            data-model="address1"
                            data-validate="text"
                        >
                            <input
                                :id="'txtStreet' + _uid"
                                :value="value.address1"
                                autocomplete="address-line1"
                                data-testing="delivery-address-de-street"
                                inputmode="text"
                                maxlength="30"
                                name="street"
                                type="text"
                                @input="
                                    let inputValue = $event.target.value;
                                    emitInputEvent(
                                        'address1',
                                        $event.target.value
                                    );
                                    clearTimer('SN2');
                                    setTimer('SN2',()=>{isAddressEmpty(inputValue, 'street', 2)});
                                "
                                @blur="
                                    clearTimer('SN2');
                                    isAddressEmpty($event.target.value, 'street', 2)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtStreet' + _uid"
                                >{{
                                    $translate("Ceres::Template.addressStreet")
                                }}*</label
                            >
                        </div>
                    </div>

                    <div class="col-12 col-sm-4">
                        <div
                            class="input-unit"
                            :class="{ 'error-without-z': isHouseNumberValid2===false, 'success-without-z': isHouseNumberValid2===true}"
                            data-model="address2"
                            data-validate="text"
                        >
                            <input
                                :id="'txtNumber' + _uid"
                                :value="value.address2"
                                autocomplete="address-line2"
                                data-testing="delivery-address-de-housenumber"
                                inputmode="text"
                                maxlength="30"
                                name="housenumber"
                                type="text"
                                @input="
                                    let inputValue = $event.target.value;
                                    emitInputEvent(
                                        'address2',
                                        $event.target.value
                                    );
                                    clearTimer('HN2');
                                    setTimer('HN2',()=>{isAddressEmpty(inputValue, 'houseNumber', 2)});
                                "
                                @blur="
                                    clearTimer('HN2');
                                    isAddressEmpty($event.target.value, 'houseNumber', 2)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtNumber' + _uid"
                                >{{
                                    $translate("Ceres::Template.addressNumber")
                                }}*</label
                            >
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="row">
                    <div
                        v-if="
                            isInOptionalFields(
                                'de',
                                'delivery_address.address3'
                            )
                        "
                        class="col-12 col-sm-6"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'delivery_address.address3'
                                )
                            "
                            class="input-unit"
                            data-model="address3"
                        >
                            <input
                                :id="'decorateAddress0' + _uid"
                                :value="value.address3"
                                inputmode="text"
                                maxlength="30"
                                name="decorateAddress"
                                type="text"
                                @input="
                                    emitInputEvent(
                                        'address3',
                                        $event.target.value
                                    )
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'decorateAddress0' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressAdditionalAddress1",
                                        "de",
                                        "delivery_address.address3"
                                    )
                                }}
                            </label>
                        </div>
                    </div>

                    <div
                        v-if="
                            isInOptionalFields(
                                'de',
                                'delivery_address.address4'
                            )
                        "
                        class="col-12 col-sm-6"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'delivery_address.address4'
                                )
                            "
                            class="input-unit"
                            data-model="address4"
                        >
                            <input
                                :id="'decorateAddress1' + _uid"
                                :value="value.address4"
                                inputmode="text"
                                maxlength="30"
                                name="decorateAddress"
                                type="text"
                                @input="
                                    emitInputEvent(
                                        'address4',
                                        $event.target.value
                                    )
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'decorateAddress1' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressAdditionalAddress2",
                                        "de",
                                        "delivery_address.address4"
                                    )
                                }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-sm-4">
                <div
                    class="input-unit"
                    :class="{ 'error-without-z': isPostalCodeValid2===false, 'success-without-z': isPostalCodeValid2===true}"
                    data-model="postalCode"
                    data-validate="postalCode"
                >
                    <input
                        class="postalCodeCustomDelivery"
                        :id="'txtZip' + _uid"
                        :value="value.postalCode"
                        data-testing="delivery-address-de-zip"
                        inputmode="numeric"
                        maxlength="4"
                        name="zip"
                        type="text"
                        pattern=".{4,4}"
                        @input="
                            let inputValue = $event.target.value;
                            emitInputEvent('postalCode', $event.target.value);
                            clearTimer('ZIP2');
                            setTimer('ZIP2',()=>{validatePostalCode(inputValue, 2)});
                        "
                        @blur="
                            clearTimer('ZIP2');
                            validatePostalCode($event.target.value, 2)
                        "
                        @keypress="onlyNumbers('postalCode', _uid, $event)"
                    />
                    <label :for="'txtZip' + _uid"
                        >{{ $translate("Ceres::Template.addressZip") }}*</label
                    >
                    <div
                        :id="'errTxtZip' + _uid"
                        :ref="'errTxtZip' + _uid"
                        class="errmsg test4 text-danger position-absolute small mt-1"
                        style="display: none"
                    >
                        {{
                            $translate("GonserDT::Template.checkoutOnlyNumbers")
                        }}
                    </div>
                    <div class="errTxtZipLengthDelivery bg-warning p-3">
                        {{ $translate("GonserDT::Template.checkoutZipLength") }}
                    </div>
                </div>
            </div>

            <div class="col-12 col-sm-4">
                <div class="input-unit" 
                    :class="{'error-without-z': isTownValid2===false, 'success-without-z': isTownValid2===true}" 
                    data-model="town" 
                    data-validate="text"
                >
                    <input
                        :id="'txtPlace' + _uid"
                        :value="value.town"
                        data-testing="delivery-address-de-town"
                        inputmode="text"
                        maxlength="30"
                        name="town"
                        type="text"
                        @input="
                            let inputValue = $event.target.value;
                            emitInputEvent('town', $event.target.value);
                            clearTimer('T2');
                            setTimer('T2',()=>{isAddressEmpty(inputValue, 'town', 2)});
                        "
                        @blur="
                            clearTimer('T2');
                            isAddressEmpty($event.target.value, 'town', 2);
                        "
                        @keypress="filterCharacters($event)"
                    />
                    <label :for="'txtPlace' + _uid"
                        >{{
                            $translate("Ceres::Template.addressPlace")
                        }}*</label
                    >
                </div>
            </div>

            <div class="col-12 col-sm-4" data-testing="address-country-select">
                <country-select
                    :address-type="addressType"
                    :optional-address-fields="optionalAddressFields"
                    :required-address-fields="requiredAddressFields"
                    :specificCountryIds="[4, 34]"
                    :selected-country-id="value.countryId"
                    :selected-state-id="value.stateId"
                    @country-changed="onSelectedCountryChanged($event)"
                    @state-changed="emitInputEvent('stateId', $event)"
                >
                </country-select>
            </div>

            <slot name="custom-address-fields"></slot>

            <!-- MailInput -->
            <div class="col-12">
                <hr class="mt-0" />
                <div class="row">
                    <div
                        v-if="
                            isInOptionalFields('de', 'delivery_address.email')
                        "
                        class="col-12"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'delivery_address.email'
                                )
                            "
                            class="input-unit"
                            data-model="email"
                        >
                            <input
                                :id="'email' + _uid"
                                :value="value.email"
                                data-testing="delivery-address-de-email-input"
                                inputmode="email"
                                maxlength="30"
                                name="email"
                                type="mail"
                                @input="
                                    emitInputEvent('email', $event.target.value)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'email' + _uid">{{
                                transformTranslation(
                                    "Ceres::Template.addressMail",
                                    "de",
                                    "delivery_address.email"
                                )
                            }}</label>
                        </div>
                    </div>
                    
                </div>
            </div>
        </template>
        <template v-else-if="localeToShow == 'DE' && addressType === '2' && !isMobile">
            <div class="col-12">
                <div class="row">
                    <div
                        v-if="
                            isInOptionalFields(
                                'de',
                                'delivery_address.salutation'
                            )
                        "
                        class="col-12 col-sm-4"
                    >
                        <div
                            v-validate="
                                isInRequiredFields(
                                    'de',
                                    'delivery_address.salutation'
                                )
                            "
                            class="input-unit"
                        >
                            <salutation-select
                                :id="'txtSalutation' + _uid"
                                :address-data="value"
                                :address-type="addressType"
                                :enabled-address-fields="optionalAddressFields"
                                @input="
                                    emitInputEvent($event.field, $event.value)
                                "
                            ></salutation-select>
                            <label :for="'txtSalutation' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressSalutation",
                                        "de",
                                        "delivery_address.salutation"
                                    )
                                }}
                            </label>
                        </div>
                    </div>
                    <div
                        v-if="
                            isInOptionalFields('de', 'delivery_address.title')
                        "
                        class="col-12 col-sm-4"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'delivery_address.title'
                                )
                            "
                            class="input-unit"
                            data-model="title"
                        >
                            <input
                                :id="'txtTitle' + _uid"
                                :value="value.title"
                                data-autofocus
                                inputmode="text"
                                maxlength="30"
                                name="title"
                                type="text"
                                @input="
                                    emitInputEvent('title', $event.target.value)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtTitle' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressTitle",
                                        "de",
                                        "delivery_address.title"
                                    )
                                }}
                            </label>
                        </div>
                    </div>

                    <template
                        v-if="areNameFieldsShown('de', 'delivery_address')"
                    >
                        <div class="col-12 col-sm-4">
                            <div
                                v-validate:text="
                                    areNameFieldsRequired(
                                        'de',
                                        'delivery_address'
                                    )
                                "
                                class="input-unit"
                                :class="{ 'error-without-z': isFirstNameValid2===false, 'success-without-z': isFirstNameValid2===true}"
                                data-model="name2"
                            >
                                <input
                                    :id="'txtFirstName' + _uid"
                                    :value="value.name2"
                                    data-autofocus
                                    data-testing="delivery-address-de-firstname"
                                    inputmode="text"
                                    maxlength="19"
                                    name="firstName"
                                    type="text"
                                    @input="
                                        let inputValue = $event.target.value;
                                        emitInputEvent(
                                            'name2',
                                            $event.target.value
                                        );
                                        clearTimer('FN2');;
                                        setTimer('FN2',()=>{isAddressEmpty(inputValue, 'firstName', 2)});
                                    "
                                    @blur="
                                        clearTimer('FN2');
                                        isAddressEmpty($event.target.value, 'firstName', 2)
                                    "
                                    @keypress="filterCharacters($event)"
                                />
                                <label :for="'txtFirstName' + _uid"
                                    >{{
                                        $translate(
                                            "Ceres::Template.addressFirstName"
                                        )
                                    }}
                                    <template
                                        v-if="
                                            areNameFieldsRequired(
                                                'de',
                                                'delivery_address'
                                            )
                                        "
                                        >*</template
                                    >
                                </label>
                            </div>
                        </div>

                        <div class="col-12 col-sm-4">
                            <div
                                v-validate:text="
                                    areNameFieldsRequired(
                                        'de',
                                        'delivery_address'
                                    )
                                "
                                class="input-unit"
                                :class="{ 'error-without-z': isLastNameValid2===false, 'success-without-z': isLastNameValid2===true}"
                                data-model="name3"
                            >
                                <input
                                    :id="'txtLastName' + _uid"
                                    :value="value.name3"
                                    data-testing="delivery-address-de-lastname"
                                    inputmode="text"
                                    maxlength="19"
                                    name="lastName"
                                    type="text"
                                    @input="
                                        let inputValue = $event.target.value;
                                        emitInputEvent(
                                            'name3',
                                            $event.target.value
                                        );
                                        clearTimer('LN2');
                                        setTimer('LN2',()=>{isAddressEmpty(inputValue, 'lastName', 2)});
                                    "
                                    @blur="
                                        clearTimer('LN2');
                                        isAddressEmpty($event.target.value, 'lastName', 2)
                                    "
                                    @keypress="filterCharacters($event)"
                                />
                                <label :for="'txtLastName' + _uid"
                                    >{{
                                        $translate(
                                            "Ceres::Template.addressLastName"
                                        )
                                    }}
                                    <template
                                        v-if="
                                            areNameFieldsRequired(
                                                'de',
                                                'delivery_address'
                                            )
                                        "
                                        >*</template
                                    >
                                </label>
                            </div>
                        </div>
                    </template>

                    <div v-else class="col-12 col-sm-8">
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'delivery_address.contactPerson'
                                )
                            "
                            class="input-unit"
                            data-model="contactPerson"
                        >
                            <input
                                :id="'txtContactPerson' + _uid"
                                :value="value.contactPerson"
                                inputmode="text"
                                maxlength="19"
                                name="lastName"
                                type="text"
                                @input="
                                    emitInputEvent(
                                        'contactPerson',
                                        $event.target.value
                                    )
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtContactPerson' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressContactPerson",
                                        "de",
                                        "delivery_address.contactPerson"
                                    )
                                }}
                            </label>
                        </div>
                    </div>

                    <div
                        v-if="
                            isInOptionalFields('de', 'delivery_address.name4')
                        "
                        class="col-12 col-sm-4"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'delivery_address.name4'
                                )
                            "
                            class="input-unit"
                            data-model="name4"
                        >
                            <input
                                :id="'txtAdditionalName' + _uid"
                                :value="value.name4"
                                inputmode="text"
                                maxlength="30"
                                name="decorateName"
                                type="text"
                                @input="
                                    emitInputEvent('name4', $event.target.value)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtAdditionalName' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressAdditionalName",
                                        "de",
                                        "delivery_address.name4"
                                    )
                                }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="row">
                    <div
                        v-if="
                            (isInOptionalFields(
                                'de',
                                'delivery_address.salutation'
                            ) &&
                                value.gender === 'company') ||
                            (isInOptionalFields(
                                'de',
                                'delivery_address.name1'
                            ) &&
                                !isInOptionalFields(
                                    'de',
                                    'delivery_address.salutation'
                                ))
                        "
                        class="col-12 col-sm-6"
                    >
                        <div
                            class="input-unit"
                            :class="{ 'error-without-z': isCompanyNameValid2===false, 'success-without-z': isCompanyNameValid2===true}"
                            data-model="name1"
                            data-validate="text"
                        >
                            <input
                                :id="'txtCompany' + _uid"
                                :value="value.name1"
                                data-autofocus
                                inputmode="text"
                                maxlength="30"
                                name="company"
                                type="text"
                                @input="
                                    emitInputEvent('name1', $event.target.value);
                                    clearTimer('C2');
                                    setTimer('C2',()=>{isAddressEmpty($event.target.value, 'company', 2)});
                                "
                                @blur="
                                    clearTimer('C2');
                                    isAddressEmpty($event.target.value, 'company', 2)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtCompany' + _uid"
                                >{{
                                    $translate(
                                        "Ceres::Template.addressCompany"
                                    )
                                }}*</label
                            >
                        </div>
                    </div>
                    <div class="col-12 col-sm-6">
                        <vat-id
                            :is-required="
                                isInRequiredFields(
                                    'de',
                                    'delivery_address.vatNumber'
                                )
                            "
                            :selected-country-id="value.countryId"
                            :show-input="
                                (isInOptionalFields(
                                    'de',
                                    'delivery_address.salutation'
                                ) &&
                                    value.gender === 'company' &&
                                    isInOptionalFields(
                                        'de',
                                        'delivery_address.vatNumber'
                                    )) ||
                                (!isInOptionalFields(
                                    'de',
                                    'delivery_address.salutation'
                                ) &&
                                    isInOptionalFields(
                                        'de',
                                        'delivery_address.name1'
                                    ) &&
                                    isInOptionalFields(
                                        'de',
                                        'delivery_address.vatNumber'
                                    ))
                            "
                            :value="value.vatNumber || ''"
                            @input="emitInputEvent('vatNumber', $event)"
                        >
                        </vat-id>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="row">
                    <div class="col-6">
                        <div
                            class="input-unit"
                            :class="{ 'error-without-z': isStreetNameValid2===false, 'success-without-z': isStreetNameValid2===true}"
                            data-model="address1"
                            data-validate="text"
                        >
                            <input
                                :id="'txtStreet' + _uid"
                                :value="value.address1"
                                autocomplete="address-line1"
                                data-testing="delivery-address-de-street"
                                inputmode="text"
                                maxlength="30"
                                name="street"
                                type="text"
                                @input="
                                    let inputValue = $event.target.value;
                                    emitInputEvent(
                                        'address1',
                                        $event.target.value
                                    );
                                    clearTimer('SN2');
                                    setTimer('SN2',()=>{isAddressEmpty(inputValue, 'street', 2)});
                                "
                                @blur="
                                    clearTimer('SN2');
                                    isAddressEmpty($event.target.value, 'street', 2)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtStreet' + _uid"
                                >{{
                                    $translate("Ceres::Template.addressStreet")
                                }}*</label
                            >
                        </div>
                    </div>

                    <div class="col-2">
                        <div
                            class="input-unit"
                            :class="{ 'error-without-z': isHouseNumberValid2===false, 'success-without-z': isHouseNumberValid2===true}"
                            data-model="address2"
                            data-validate="text"
                        >
                            <input
                                :id="'txtNumber' + _uid"
                                :value="value.address2"
                                autocomplete="address-line2"
                                data-testing="delivery-address-de-housenumber"
                                inputmode="text"
                                maxlength="30"
                                name="housenumber"
                                type="text"
                                @input="
                                    let inputValue = $event.target.value;
                                    emitInputEvent(
                                        'address2',
                                        $event.target.value
                                    );
                                    clearTimer('HN2');
                                    setTimer('HN2',()=>{isAddressEmpty(inputValue, 'houseNumber', 2)});
                                "
                                @blur="
                                    clearTimer('HN2');
                                    isAddressEmpty($event.target.value, 'houseNumber', 2)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtNumber' + _uid"
                                >{{
                                    $translate("Ceres::Template.addressNumber")
                                }}*</label
                            >
                        </div>
                    </div>
                    
                    <div
                        v-if="
                            isInOptionalFields(
                                'de',
                                'delivery_address.phoneNumber'
                            )
                        "
                        class="col-4"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'delivery_address.phoneNumber'
                                )
                            "
                            class="input-unit"
                            data-model="telephone"
                        >
                            <input
                                :id="'txtTelephone' + _uid"
                                :value="value.telephone"
                                inputmode="tel"
                                maxlength="30"
                                name="telephone"
                                type="tel"
                                @input="
                                    emitInputEvent(
                                        'telephone',
                                        $event.target.value
                                    )
                                "
                                @keypress="
                                    onlyNumbers('telephone', _uid, $event)
                                "
                            />
                            <label :for="'txtTelephone' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressTelephone",
                                        "de",
                                        "delivery_address.phoneNumber"
                                    )
                                }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="isParcelOrOfficeAvailable" class="col-12">
                <div class="row">
                    <div class="col-12">
                        <input
                            :id="'showPickup' + _uid"
                            :checked="value.showPickupStation"
                            name="togglePickup"
                            type="checkbox"
                            @change="togglePickupStation($event.target.checked)"
                        />
                        <label :for="'showPickup' + _uid">{{
                            $translate("Ceres::Template.addressToPickupStation")
                        }}</label>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="row">
                    <div
                        v-if="
                            isInOptionalFields(
                                'de',
                                'delivery_address.address3'
                            )
                        "
                        class="col-12 col-sm-6"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'delivery_address.address3'
                                )
                            "
                            class="input-unit"
                            data-model="address3"
                        >
                            <input
                                :id="'decorateAddress0' + _uid"
                                :value="value.address3"
                                inputmode="text"
                                maxlength="30"
                                name="decorateAddress"
                                type="text"
                                @input="
                                    emitInputEvent(
                                        'address3',
                                        $event.target.value
                                    )
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'decorateAddress0' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressAdditionalAddress1",
                                        "de",
                                        "delivery_address.address3"
                                    )
                                }}
                            </label>
                        </div>
                    </div>

                    <div
                        v-if="
                            isInOptionalFields(
                                'de',
                                'delivery_address.address4'
                            )
                        "
                        class="col-12 col-sm-6"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'delivery_address.address4'
                                )
                            "
                            class="input-unit"
                            data-model="address4"
                        >
                            <input
                                :id="'decorateAddress1' + _uid"
                                :value="value.address4"
                                inputmode="text"
                                maxlength="30"
                                name="decorateAddress"
                                type="text"
                                @input="
                                    emitInputEvent(
                                        'address4',
                                        $event.target.value
                                    )
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'decorateAddress1' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressAdditionalAddress2",
                                        "de",
                                        "delivery_address.address4"
                                    )
                                }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-sm-4">
                <div
                    class="input-unit"
                    :class="{ 'error-without-z': isPostalCodeValid2===false, 'success-without-z': isPostalCodeValid2===true}"
                    data-model="postalCode"
                    data-validate="postalCode"
                >
                    <input
                        class="postalCodeCustomDelivery"
                        :id="'txtZip' + _uid"
                        :value="value.postalCode"
                        data-testing="delivery-address-de-zip"
                        inputmode="numeric"
                        maxlength="4"
                        name="zip"
                        type="text"
                        pattern=".{4,4}"
                        @input="
                            let inputValue = $event.target.value;
                            emitInputEvent('postalCode', $event.target.value);
                            clearTimer('ZIP2');
                            setTimer('ZIP2',()=>{validatePostalCode(inputValue, 2)});
                        "
                        @blur="
                            clearTimer('ZIP2');
                            validatePostalCode($event.target.value, 2)
                        "
                        @keypress="onlyNumbers('postalCode', _uid, $event)"
                    />
                    <label :for="'txtZip' + _uid"
                        >{{ $translate("Ceres::Template.addressZip") }}*</label
                    >
                    <div
                        :id="'errTxtZip' + _uid"
                        :ref="'errTxtZip' + _uid"
                        class="errmsg test4 text-danger position-absolute small mt-1"
                        style="display: none"
                    >
                        {{
                            $translate("GonserDT::Template.checkoutOnlyNumbers")
                        }}
                    </div>
                    <div class="errTxtZipLengthDelivery bg-warning p-3">
                        {{ $translate("GonserDT::Template.checkoutZipLength") }}
                    </div>
                </div>
            </div>

            <div class="col-12 col-sm-4">
                <div class="input-unit" 
                    :class="{'error-without-z': isTownValid2===false, 'success-without-z': isTownValid2===true}" 
                    data-model="town" 
                    data-validate="text"
                >
                    <input
                        :id="'txtPlace' + _uid"
                        :value="value.town"
                        data-testing="delivery-address-de-town"
                        inputmode="text"
                        maxlength="30"
                        name="town"
                        type="text"
                        @input="
                            let inputValue = $event.target.value;
                            emitInputEvent('town', $event.target.value);
                            clearTimer('T2');
                            setTimer('T2',()=>{isAddressEmpty(inputValue, 'town', 2)});
                        "
                        @blur="
                            clearTimer('T2');
                            isAddressEmpty($event.target.value, 'town', 2);
                        "
                        @keypress="filterCharacters($event)"
                    />
                    <label :for="'txtPlace' + _uid"
                        >{{
                            $translate("Ceres::Template.addressPlace")
                        }}*</label
                    >
                </div>
            </div>

            <div class="col-12 col-sm-4" data-testing="address-country-select">
                <country-select
                    :address-type="addressType"
                    :optional-address-fields="optionalAddressFields"
                    :required-address-fields="requiredAddressFields"
                    :specificCountryIds="[4, 34]"
                    :selected-country-id="value.countryId"
                    :selected-state-id="value.stateId"
                    @country-changed="onSelectedCountryChanged($event)"
                    @state-changed="emitInputEvent('stateId', $event)"
                >
                </country-select>
            </div>

            <slot name="custom-address-fields"></slot>

            <!-- MailInput -->
            <div class="col-12">
                <hr class="mt-0" />
                <div class="row">
                    <div
                        v-if="
                            isInOptionalFields('de', 'delivery_address.email')
                        "
                        class="col-12"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'de',
                                    'delivery_address.email'
                                )
                            "
                            class="input-unit"
                            data-model="email"
                        >
                            <input
                                :id="'email' + _uid"
                                :value="value.email"
                                data-testing="delivery-address-de-email-input"
                                inputmode="email"
                                maxlength="30"
                                name="email"
                                type="mail"
                                @input="
                                    emitInputEvent('email', $event.target.value)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'email' + _uid">{{
                                transformTranslation(
                                    "Ceres::Template.addressMail",
                                    "de",
                                    "delivery_address.email"
                                )
                            }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <!-- DeliveryAddressGB -->
        <template v-else-if="localeToShow == 'GB' && addressType === '2'">
            <div class="col-12">
                <div class="row">
                    <div
                        v-if="
                            isInOptionalFields(
                                'gb',
                                'delivery_address.salutation'
                            )
                        "
                        class="col-12 col-sm-4"
                    >
                        <div
                            v-validate="
                                isInRequiredFields(
                                    'gb',
                                    'delivery_address.salutation'
                                )
                            "
                            class="input-unit"
                        >
                            <salutation-select
                                :id="'txtSalutation' + _uid"
                                :address-data="value"
                                :address-type="addressType"
                                :enabled-address-fields="optionalAddressFields"
                                @input="
                                    emitInputEvent($event.field, $event.value)
                                "
                            ></salutation-select>
                            <label :for="'txtSalutation' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressSalutation",
                                        "gb",
                                        "delivery_address.salutation"
                                    )
                                }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="row">
                    <div
                        v-if="
                            (isInOptionalFields(
                                'gb',
                                'delivery_address.salutation'
                            ) &&
                                value.gender === 'company') ||
                            (isInOptionalFields(
                                'gb',
                                'delivery_address.name1'
                            ) &&
                                !isInOptionalFields(
                                    'gb',
                                    'delivery_address.salutation'
                                ))
                        "
                        class="col-12 col-sm-6"
                    >
                        <div
                            class="input-unit"
                            data-model="name1"
                            data-validate="text"
                        >
                            <input
                                :id="'txtCompany' + _uid"
                                :value="value.name1"
                                data-autofocus
                                inputmode="text"
                                maxlength="30"
                                name="company"
                                type="text"
                                @input="
                                    emitInputEvent('name1', $event.target.value)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtCompany' + _uid"
                                >{{
                                    $translate(
                                        "Ceres::Template.addressCompany"
                                    )
                                }}*</label
                            >
                        </div>
                    </div>
                    <div class="col-12 col-sm-6">
                        <vat-id
                            :is-required="
                                isInRequiredFields(
                                    'gb',
                                    'delivery_address.vatNumber'
                                )
                            "
                            :selected-country-id="value.countryId"
                            :show-input="
                                (isInOptionalFields(
                                    'gb',
                                    'delivery_address.salutation'
                                ) &&
                                    value.gender === 'company' &&
                                    isInOptionalFields(
                                        'gb',
                                        'delivery_address.vatNumber'
                                    )) ||
                                (!isInOptionalFields(
                                    'gb',
                                    'delivery_address.salutation'
                                ) &&
                                    isInOptionalFields(
                                        'gb',
                                        'delivery_address.name1'
                                    ) &&
                                    isInOptionalFields(
                                        'gb',
                                        'delivery_address.vatNumber'
                                    ))
                            "
                            :value="value.vatNumber || ''"
                            @input="emitInputEvent('vatNumber', $event)"
                        >
                        </vat-id>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="row">
                    <div
                        v-if="
                            isInOptionalFields('gb', 'delivery_address.title')
                        "
                        class="col-12 col-sm-4"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'gb',
                                    'delivery_address.title'
                                )
                            "
                            class="input-unit"
                            data-model="title"
                        >
                            <input
                                :id="'txtTitle' + _uid"
                                :value="value.title"
                                data-autofocus
                                inputmode="text"
                                maxlength="30"
                                name="title"
                                type="text"
                                @input="
                                    emitInputEvent('title', $event.target.value)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtTitle' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressTitle",
                                        "gb",
                                        "delivery_address.title"
                                    )
                                }}
                            </label>
                        </div>
                    </div>

                    <template
                        v-if="areNameFieldsShown('gb', 'delivery_address')"
                    >
                        <div class="col-12 col-sm-4">
                            <div
                                v-validate:text="
                                    areNameFieldsRequired(
                                        'gb',
                                        'delivery_address'
                                    )
                                "
                                class="input-unit"
                                data-model="name2"
                            >
                                <input
                                    :id="'txtFirstName' + _uid"
                                    :value="value.name2"
                                    data-autofocus
                                    inputmode="text"
                                    maxlength="19"
                                    name="firstName"
                                    type="text"
                                    @input="
                                        emitInputEvent(
                                            'name2',
                                            $event.target.value
                                        )
                                    "
                                    @keypress="filterCharacters($event)"
                                />
                                <label :for="'txtFirstName' + _uid"
                                    >{{
                                        $translate(
                                            "Ceres::Template.addressFirstName"
                                        )
                                    }}
                                    <template
                                        v-if="
                                            areNameFieldsRequired(
                                                'gb',
                                                'delivery_address'
                                            )
                                        "
                                        >*</template
                                    >
                                </label>
                            </div>
                        </div>

                        <div class="col-12 col-sm-4">
                            <div
                                v-validate:text="
                                    areNameFieldsRequired(
                                        'gb',
                                        'delivery_address'
                                    )
                                "
                                class="input-unit"
                                data-model="name3"
                            >
                                <input
                                    :id="'txtLastName' + _uid"
                                    :value="value.name3"
                                    inputmode="text"
                                    maxlength="19"
                                    name="lastName"
                                    type="text"
                                    @input="
                                        emitInputEvent(
                                            'name3',
                                            $event.target.value
                                        )
                                    "
                                    @keypress="filterCharacters($event)"
                                />
                                <label :for="'txtLastName' + _uid"
                                    >{{
                                        $translate(
                                            "Ceres::Template.addressLastName"
                                        )
                                    }}
                                    <template
                                        v-if="
                                            areNameFieldsRequired(
                                                'gb',
                                                'delivery_address'
                                            )
                                        "
                                        >*</template
                                    >
                                </label>
                            </div>
                        </div>
                    </template>

                    <div v-else class="col-12 col-sm-8">
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'gb',
                                    'delivery_address.contactPerson'
                                )
                            "
                            class="input-unit"
                            data-model="contactPerson"
                        >
                            <input
                                :id="'txtContactPerson' + _uid"
                                :value="value.contactPerson"
                                inputmode="text"
                                maxlength="19"
                                name="lastName"
                                type="text"
                                @input="
                                    emitInputEvent(
                                        'contactPerson',
                                        $event.target.value
                                    )
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtContactPerson' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressContactPerson",
                                        "gb",
                                        "delivery_address.contactPerson"
                                    )
                                }}
                            </label>
                        </div>
                    </div>

                    <div
                        v-if="
                            isInOptionalFields('gb', 'delivery_address.name4')
                        "
                        class="col-12 col-sm-4"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'gb',
                                    'delivery_address.name4'
                                )
                            "
                            class="input-unit"
                            data-model="name4"
                        >
                            <input
                                :id="'txtAdditionalName' + _uid"
                                :value="value.name4"
                                inputmode="text"
                                maxlength="30"
                                name="decorateName"
                                type="text"
                                @input="
                                    emitInputEvent('name4', $event.target.value)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtAdditionalName' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressGBNameAffix",
                                        "gb",
                                        "delivery_address.name4"
                                    )
                                }}
                            </label>
                        </div>
                    </div>

                    <div
                        v-if="
                            isInOptionalFields(
                                'gb',
                                'delivery_address.phoneNumber'
                            )
                        "
                        class="col-12 col-sm-4"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'gb',
                                    'delivery_address.phoneNumber'
                                )
                            "
                            class="input-unit"
                            data-model="telephone"
                        >
                            <input
                                :id="'txtTelephone' + _uid"
                                :value="value.telephone"
                                inputmode="tel"
                                maxlength="30"
                                name="telephone"
                                type="tel"
                                @input="
                                    emitInputEvent(
                                        'telephone',
                                        $event.target.value
                                    )
                                "
                                @keypress="
                                    onlyNumbers('telephone', _uid, $event)
                                "
                            />
                            <label :for="'txtTelephone' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressTelephone",
                                        "gb",
                                        "delivery_address.phoneNumber"
                                    )
                                }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="row">
                    <div class="col-12 col-sm-8">
                        <div
                            class="input-unit"
                            data-model="address1"
                            data-validate="text"
                        >
                            <input
                                :id="'txtStreet' + _uid"
                                :value="value.address1"
                                autocomplete="address-line1"
                                inputmode="text"
                                maxlength="30"
                                name="street"
                                type="text"
                                @input="
                                    emitInputEvent(
                                        'address1',
                                        $event.target.value
                                    )
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtStreet' + _uid"
                                >{{
                                    $translate(
                                        "Ceres::Template.addressENAddressLine1"
                                    )
                                }}*</label
                            >
                        </div>
                    </div>

                    <div
                        v-if="
                            isInOptionalFields(
                                'gb',
                                'delivery_address.address2'
                            )
                        "
                        class="col-12 col-sm-12"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'gb',
                                    'delivery_address.address2'
                                )
                            "
                            class="input-unit"
                            data-model="address2"
                        >
                            <input
                                :id="'txtNumber' + _uid"
                                :value="value.address2"
                                autocomplete="address-line2"
                                inputmode="text"
                                maxlength="30"
                                name="housenumber"
                                type="text"
                                @input="
                                    emitInputEvent(
                                        'address2',
                                        $event.target.value
                                    )
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'txtNumber' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressENAddressLine2",
                                        "gb",
                                        "delivery_address.address2"
                                    )
                                }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="row">
                    <div
                        v-if="
                            isInOptionalFields(
                                'gb',
                                'delivery_address.address3'
                            )
                        "
                        class="col-12 col-sm-6"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'gb',
                                    'delivery_address.address3'
                                )
                            "
                            class="input-unit"
                            data-model="address3"
                        >
                            <input
                                :id="'decorateAddress0' + _uid"
                                :value="value.address3"
                                inputmode="text"
                                maxlength="30"
                                name="buildingName"
                                type="text"
                                @input="
                                    emitInputEvent(
                                        'address3',
                                        $event.target.value
                                    )
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'decorateAddress0' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressENAddressLine3",
                                        "gb",
                                        "delivery_address.address3"
                                    )
                                }}
                            </label>
                        </div>
                    </div>

                    <div
                        v-if="
                            isInOptionalFields(
                                'gb',
                                'delivery_address.address4'
                            )
                        "
                        class="col-12 col-sm-12"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'gb',
                                    'delivery_address.address4'
                                )
                            "
                            class="input-unit"
                            data-model="address4"
                        >
                            <input
                                :id="'decorateAddress1' + _uid"
                                :value="value.address4"
                                inputmode="text"
                                maxlength="30"
                                name="buildingName"
                                type="text"
                                @input="
                                    emitInputEvent(
                                        'address4',
                                        $event.target.value
                                    )
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'decorateAddress1' + _uid">
                                {{
                                    transformTranslation(
                                        "Ceres::Template.addressENAddressLine4",
                                        "gb",
                                        "delivery_address.address4"
                                    )
                                }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-sm-4">
                <div class="input-unit" data-model="town" data-validate="text">
                    <input
                        :id="'txtPlace' + _uid"
                        :value="value.town"
                        inputmode="text"
                        maxlength="30"
                        name="town"
                        type="text"
                        @input="emitInputEvent('town', $event.target.value)"
                        @keypress="filterCharacters($event)"
                    />
                    <label :for="'txtPlace' + _uid"
                        >{{
                            $translate("Ceres::Template.addressPlace")
                        }}*</label
                    >
                </div>
            </div>

            <div class="col-12 col-sm-4">
                <div
                    class="input-unit"
                    data-model="postalCode"
                    data-validate="postalCode"
                >
                    <input
                        :id="'txtZip' + _uid"
                        :value="value.postalCode"
                        inputmode="numeric"
                        maxlength="4"
                        name="zip"
                        type="text"
                        @input="
                            emitInputEvent('postalCode', $event.target.value)
                        "
                        @keypress="onlyNumbers('postalCode', _uid, $event)"
                        pattern=".{4,4}"
                    />
                    <label :for="'txtZip' + _uid"
                        >{{ $translate("Ceres::Template.addressZip") }}*</label
                    >
                    <div
                        :id="'errTxtZip' + _uid"
                        :ref="'errTxtZip' + _uid"
                        class="errmsg test5 text-danger position-absolute small mt-1"
                        style="display: none"
                    >
                        {{
                            $translate("GonserDT::Template.checkoutOnlyNumbers")
                        }}
                    </div>
                </div>
            </div>

            <div class="col-12 col-sm-4" data-testing="address-country-select">
                <country-select
                    :address-type="addressType"
                    :optional-address-fields="optionalAddressFields"
                    :required-address-fields="requiredAddressFields"
                    :specificCountryIds="[4, 34]"
                    :selected-country-id="value.countryId"
                    :selected-state-id="value.stateId"
                    @country-changed="onSelectedCountryChanged($event)"
                    @state-changed="emitInputEvent('stateId', $event)"
                >
                </country-select>
            </div>

            <slot name="custom-address-fields"></slot>

            <!-- MailInput -->
            <div class="col-12">
                <hr class="mt-0" />
                <div class="row">
                    <div
                        v-if="
                            isInOptionalFields('gb', 'delivery_address.email')
                        "
                        class="col-12"
                    >
                        <div
                            v-validate:text="
                                isInRequiredFields(
                                    'gb',
                                    'delivery_address.email'
                                )
                            "
                            class="input-unit"
                            data-model="email"
                        >
                            <input
                                :id="'email' + _uid"
                                :value="value.email"
                                data-testing="delivery-address-gb-email-input"
                                inputmode="email"
                                maxlength="30"
                                name="email"
                                type="mail"
                                @input="
                                    emitInputEvent('email', $event.target.value)
                                "
                                @keypress="filterCharacters($event)"
                            />
                            <label :for="'email' + _uid">{{
                                transformTranslation(
                                    "Ceres::Template.addressMail",
                                    "gb",
                                    "delivery_address.email"
                                )
                            }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { mapState } from "vuex";
import SalutationSelect from "./SalutationSelect.vue";
import CountrySelect from "../customer/CountrySelect.vue";
import VatId from "./VatId.vue";
import { replaceAll } from "../../../../../js/src/app/helper/strings";
import { isNullOrUndefined } from "../../../../../js/src/app/helper/utils";
import { updateWith } from "lodash";

export default {
    name: "address-input-group",

    components: {
        SalutationSelect,
        CountrySelect,
        VatId,
    },

    props: {
        defaultCountry: {
            type: String,
            default: "DE",
        },
        addressType: String,
        modalType: String,
        template: String,
        value: {
            type: Object,
            default() {
                return {};
            },
        },
        optionalAddressFields: {
            type: Object,
            default: () => {
                return {
                    de: [],
                    uk: [],
                };
            },
        },
        requiredAddressFields: {
            type: Object,
            default: () => {
                return {
                    de: [],
                    uk: [],
                };
            },
        },
        defaultSalutation: {
            type: String,
            default: App.config.addresses.defaultSalutation,
        },
    },

    computed: {
        isMyAccount() {
            return App.templateType === "my-account";
        },

        isPickupStation() {
            return (
                this.value &&
                this.value.address1 === "PACKSTATION" &&
                this.isParcelBoxAvailable
            );
        },

        isPostOffice() {
            return (
                this.value &&
                this.value.address1 === "POSTFILIALE" &&
                this.isPostOfficeAvailable
            );
        },

        isParcelOrOfficeAvailable() {
            return (
                (this.isParcelBoxAvailable || this.isPostOfficeAvailable) &&
                this.selectedCountry &&
                this.selectedCountry.isoCode2 === "DE" &&
                this.addressType === "2"
            );
        },

        ...mapState({
            isParcelBoxAvailable: (state) =>
                state.checkout.shipping.isParcelBoxAvailable,
            isPostOfficeAvailable: (state) =>
                state.checkout.shipping.isPostOfficeAvailable,
        }),
    },
    
    watch: {
        // Save the address in the session storage
        value: {
        handler(newValue) {
            if (this.addressType === "1"){
                const { countryId, gender, ...rest } = newValue;
                if (Object.values(rest).some(v => v !== null && v !== '')) {
                    let existingData = window.sessionStorage.getItem('address');

                    existingData = existingData ? JSON.parse(existingData) : {};

                    const mergedData = { ...existingData, ...newValue };
                    
                    window.sessionStorage.setItem('address', JSON.stringify(mergedData));
                };
                if (newValue.name1 !== "" && newValue.name1 !== undefined){
                    this.isAddressEmpty(newValue.name1, 'company', '1');
                }
                if (newValue.name2 !== "" && newValue.name2 !== undefined){
                    this.isAddressEmpty(newValue.name2, 'firstName', '1');
                }
                if (newValue.name3 !== "" && newValue.name3 !== undefined){
                    this.isAddressEmpty(newValue.name3, 'lastName', '1');
                }
                if (newValue.address1 !== "" && newValue.address1 !== undefined){
                    this.isAddressEmpty(newValue.address1, 'street', '1');
                }
                if (newValue.address2 !== "" && newValue.address2 !== undefined){
                    this.isAddressEmpty(newValue.address2, 'houseNumber', '1');
                }
                if (newValue.town !== "" && newValue.town !== undefined){
                    this.isAddressEmpty(newValue.town, 'town', '1');
                }
                if (newValue.postalCode !== "" && newValue.postalCode !== undefined){
                    this.validatePostalCode(newValue.postalCode, '1');
                }
            } else if (this.addressType === "2"){
                const { countryId, gender, ...rest } = newValue;
                if (Object.values(rest).some(v => v !== null && v !== '')) {
                    let existingData = window.sessionStorage.getItem('deliveryAddress');

                    existingData = existingData ? JSON.parse(existingData) : {};

                    const mergedData = { ...existingData, ...newValue };
                    
                    window.sessionStorage.setItem('deliveryAddress', JSON.stringify(mergedData));
                };
                if (newValue.name1 !== "" && newValue.name1 !== undefined){
                    this.isAddressEmpty(newValue.name1, 'company', '2');
                }
                if (newValue.name2 !== "" && newValue.name2 !== undefined){
                    this.isAddressEmpty(newValue.name2, 'firstName', '2');
                }
                if (newValue.name3 !== "" && newValue.name3 !== undefined){
                    this.isAddressEmpty(newValue.name3, 'lastName', '2');
                }
                if (newValue.address1 !== "" && newValue.address1 !== undefined){
                    this.isAddressEmpty(newValue.address1, 'street', '2');
                }
                if (newValue.address2 !== "" && newValue.address2 !== undefined){
                    this.isAddressEmpty(newValue.address2, 'houseNumber', '2');
                }
                if (newValue.town !== "" && newValue.town !== undefined){
                    this.isAddressEmpty(newValue.town, 'town', '2');
                }
                if (newValue.postalCode !== "" && newValue.postalCode !== undefined){
                    this.validatePostalCode(newValue.postalCode, '2');
                }
            }
            
        },
        deep: true
        }
    },

    created() {
        window.addEventListener('resize', this.updateWidth);
    },
    destroyed() {
        window.removeEventListener('resize', this.updateWidth);
    },

    data() {
        return {
            stateList: [],
            countryLocaleList: ["DE", "GB"],
            localeToShow: this.defaultCountry,
            selectedCountry: null,
            isCompanyValid1: null,
            isCompanyValid2: null,
            isFirstNameValid1: null,
            isFirstNameValid2: null,
            isLastNameValid1: null,
            isLastNameValid2: null,
            isStreetNameValid1: null,
            isStreetNameValid2: null,
            isHouseNumberValid1: null,
            isHouseNumberValid2: null,
            isTownValid1: null,
            isTownValid2: null,
            isPostalCodeValid1: null,
            isPostalCodeValid2: null,
            inputTimers: {
                C1: null,
                C2: null,
                FN1: null,
                FN2: null,
                LN1: null,
                LN2: null,
                SN1: null,
                SN2: null,
                HN1: null,
                HN2: null,
                T1: null,
                T2: null,
                ZIP1: null,
                ZIP2: null,
            },
            isMobile: window.innerWidth < 576,
            
        };
    },

    methods: {
        /**
         * Update the address input group to show.
         * @param shippingCountry
         */
        onSelectedCountryChanged(shippingCountry) {
            this.selectedCountry = shippingCountry;
            if (this.countryLocaleList.indexOf(shippingCountry.isoCode2) >= 0) {
                this.localeToShow = shippingCountry.isoCode2;
            } else {
                this.localeToShow = this.defaultCountry;
            }

            this.emitInputEvent("countryId", shippingCountry.id);

            if (this.isPickupStation || this.isPostOffice) {
                this.togglePickupStation(false);
            }
        },

        togglePickupStation(showPickupStation) {
            const emitInputs = {
                address1: "",
                address2: "",
                address3: "",
                showPickupStation: showPickupStation,
            };

            if (showPickupStation) {
                emitInputs.address1 = this.isParcelBoxAvailable
                    ? "PACKSTATION"
                    : "POSTFILIALE";
            }

            for (const input in emitInputs) {
                this.emitInputEvent(input, emitInputs[input]);
            }
        },

        onlyNumbers(field, uid, event) {
            if (
                event.which !== 8 &&
                event.which !== 0 &&
                (event.which < 48 || event.which > 57)
            ) {
                if (field === "postalCode") {
                    $(this.$refs["errTxtZip" + uid])
                        .show()
                        .fadeOut("slow");
                }
                event.preventDefault();
                return false;
            }
        },

        filterCharacters(event) {
            if (event.which === 34 || event.which === 59) {
                event.preventDefault();
                return false;
            }
        },

        /**
         * @param {string} field
         * @param {string|number} value
         */
        emitInputEvent(field, value) {
            if (!isNullOrUndefined(value)) {
                if (field === "postalCode" || field === "telephone") {
                    value = value.replaceAll(/[\D]/g, "");
                } else if (field !== "countryId" || field === "stateId") {
                    value = value.replaceAll(/[;|"]/g, "");
                }
            }
            this.$emit("input", { field, value });
        },
        isAddressEmpty(value, adressInformation, adress1or2){ //check if the adress fields are empty
            let fieldEmpty = value.trim() !=="";
            if (adress1or2 == "1") {
                if (adressInformation == "company")
                {
                    this.isCompanyValid1 = fieldEmpty;
                } else if (adressInformation == "firstName")
                {
                    this.isFirstNameValid1 = fieldEmpty;
                } else if (adressInformation == "lastName")
                {
                    this.isLastNameValid1 = fieldEmpty;
                } else if (adressInformation == "street")
                {
                    this.isStreetNameValid1 = fieldEmpty;
                } else if (adressInformation == "houseNumber")
                {
                    this.isHouseNumberValid1 = fieldEmpty;
                } else if (adressInformation == "town")
                {
                    this.isTownValid1 = fieldEmpty;
                } else if (adressInformation == "email")
                {
                    this.isEmailValid = fieldEmpty;
                }
            } else {
                if (this.isCompanyValid2){
                    this.isCompanyValid2 = fieldEmpty;
                } else if (adressInformation == "firstName")
                {
                    this.isFirstNameValid2 = fieldEmpty;
                } else if (adressInformation == "lastName")
                {
                    this.isLastNameValid2 = fieldEmpty;
                } else if (adressInformation == "street")
                {
                    this.isStreetNameValid2 = fieldEmpty;
                } else if (adressInformation == "houseNumber")
                {
                    this.isHouseNumberValid2 = fieldEmpty;
                } else if (adressInformation == "town")
                {
                    this.isTownValid2 = fieldEmpty;
                }
            }
        },
        validatePostalCode(value, adress1or2) { //check if the postal code is exactly 4 digits
            let isValid = /^\d{4}$/.test(value);
            if (adress1or2 == "1") {
                this.isPostalCodeValid1 = isValid;
            } else {
                this.isPostalCodeValid2 = isValid;
            }
        },

        isInOptionalFields(locale, key) {
            return this.optionalAddressFields[locale].includes(key);
        },

        isInRequiredFields(locale, key) {
            return (
                this.requiredAddressFields &&
                this.requiredAddressFields[locale] &&
                this.requiredAddressFields[locale].includes(key)
            );
        },

        transformTranslation(translationKey, locale, addressKey) {
            const translation = this.$translate(translationKey);
            const isRequired = this.isInRequiredFields(locale, addressKey);

            return translation + (isRequired ? "*" : "");
        },

        areNameFieldsShown(locale, keyPrefix) {
            const isSalutationActive = this.isInOptionalFields(
                locale,
                `${keyPrefix}.salutation`
            );
            const isContactPersonActive = this.isInOptionalFields(
                locale,
                `${keyPrefix}.contactPerson`
            );
            const isName1Active = this.isInOptionalFields(
                locale,
                `${keyPrefix}.name1`
            );
            const isSelectedSalutationCompany = this.value.gender === "company";

            const condition1 =
                isSalutationActive &&
                isContactPersonActive &&
                isSelectedSalutationCompany;
            const condition2 =
                !isSalutationActive && isName1Active && isContactPersonActive;

            return !(condition1 || condition2);
        },

        areNameFieldsRequired(locale, keyPrefix) {
            const isSalutationActive = this.isInOptionalFields(
                locale,
                `${keyPrefix}.salutation`
            );
            const isName1Active = this.isInOptionalFields(
                locale,
                `${keyPrefix}.name1`
            );
            const isContactPersonRequired = this.isInRequiredFields(
                locale,
                `${keyPrefix}.contactPerson`
            );
            const isSelectedSalutationCompany = this.value.gender === "company";

            const condition1 =
                isSalutationActive; // && !isSelectedSalutationCompany
            const condition2 =
                isSalutationActive &&
                isSelectedSalutationCompany &&
                isContactPersonRequired;
            const condition3 =
                !isSalutationActive && isName1Active && isContactPersonRequired;
            const condition4 = !isSalutationActive && !isName1Active;

            return condition1 || condition2 || condition3 || condition4;
        },

        clearTimer(timer) {
            clearTimeout(this.inputTimers[timer]);
        },

        setTimer(timer, fn) {
            this.inputTimers[timer] = setTimeout(fn, 1000);
        },
        updateWidth() {
            this.isMobile = window.innerWidth < 576;
        }
    },
};
</script>
